import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { findLast, keyBy, isEmpty, cloneDeep, compact, filter, unionBy, sumBy, sum, pick, forEach, groupBy, omit, sortBy, flatten, map, findLastIndex, each, get, some, minBy, reverse } from '@dt/fe-utils/dist/lodash'
import { store, ddayjs, pk as doPk, toDecimal, parseString } from '@dt/fe-utils'
import {
  restaurantCenter,
  productSaleMobx,
  restaurantConfig,
  storeMobx,
  orderMobx,
  menuMobx,
  discountMobx,
  feeMobx,
  RESTAURANT_EVENT,
  cartMobx
} from '..'
import { getModifierStrAndModifierPrice, createFkey, convertDoModifierGroupsToModifierGroups, convertModifierGroupsToDoModifierGroups } from './center/cookware'
import { TCartitemDisabledReason } from './center/restaurantCenter'
import deskMobx from './desk.mobx'
import cartAuto from './cart.auto'
import productMobx from './product.mobx'
import allMenuMobx from './allMenu.mobx'
import doProductMobx from './doProduct.mobx'
import OrderAPI from 'api/order.api'
import boxFeeMobx from './boxFee.mobx'

export enum TSaveCartError {
  OVER_LIMIT = 'OVER_LIMIT',
  DATA_ERROR = 'DATA_ERROR'
}

/**
 * 点单渠道
 */
export enum TEChannel {
  // 手机
  Mobile = 'mobile',
  SelfDelivery = 'selfDelivery',
  Pos = 'pos',
  ThirdDelivery = '3rdDelivery',
  Meituan = 'meituan',
  Eleme = 'eleme',
  Douyin = 'douyin',
  Kiosk = 'kiosk',
  BuyTogether = 'buyTogether',
  CallPos = 'callPos',
  GroupMeal = 'groupMeal',
  Deliverect = 'deliverect',
}

// 创建一个新的购物车项
function createCartItem ({
  type,
  startTime,
  pickTimeRange,
  productNo,
  fkey,
  scaleNo,
  price,
  modifierGroups,
  productGroups,
  isTogo,
  isCanTogo,
  isSingleSale,
  cnt = 1,
  remark = '',
  seat = '',
  startTimeOffset = 0,
  pk,
  addUserId = '',
  addUserName = '',
  addUserAvatar = '',
  isTaxFree = false,
  swapBuyProducts,
  timestamp,
  fullItemNFreeProducts,
  isOrderSwapBuy,
  openPriceX,
  salesCnt
}: { isOrderSwapBuy?: boolean; type: string; startTime?: string; pickTimeRange?: any; productNo: string; fkey: string; price?: number; scaleNo: string; modifierGroups: ICartModifierGroup[]; productGroups?: IViewComboCartGroup[]; isTogo: 0 | 1; isCanTogo?: boolean; isSingleSale?: boolean; cnt?: number; remark: string; seat?: string; startTimeOffset: number; pk?: string; addUserId?: string; addUserName?: string; addUserAvatar?: string; isTaxFree?: boolean; swapBuyProducts?: ICartItem[] | IViewCartItem[]; timestamp?: number; fullItemNFreeProducts?: ICartItem[] | IViewCartItem[]; openPriceX?: number; salesCnt?: number }) {
  // 处理口味，先过滤掉未选择的item项
  const productData = productMobx.noToViewProductMap[productNo]
  if (!productData) {
    console.error('product is not exist')
    return
  }
  console.log('test productData.scales', productData.scales)
  const theScale = productData.scales?.find(scale => scale.no === scaleNo)
  if (!theScale) {
    console.error('the scale is not exist')
    return
  }
  return {
    type,
    productNo,
    name: productData.name,
    price,
    cnt,
    remark,
    fkey,
    startTime,
    pickTimeRange,
    startTimeOffset,
    pk: pk || doPk(),
    scaleNo: theScale.no,
    scaleName: theScale.name,
    isTogo,
    isCanTogo,
    isSingleSale,
    modifierGroups,
    addUserId,
    addUserName,
    addUserAvatar,
    isTaxFree,
    seat,
    openPriceX,
    timestamp: timestamp || ddayjs().valueOf(),
    isOrderSwapBuy,
    salesCnt,
    ...(productGroups ? { productGroups } : null),
    ...(swapBuyProducts ? { swapBuyProducts } : null),
    ...(fullItemNFreeProducts ? { fullItemNFreeProducts } : null)
  } as ICartItem
}

// 获取购物车初始化
function getCartInitialInfo (payMode?: 0 | 1, eatType?: TEatType) {
  const noEatType = restaurantCenter.config.app === 'mobile' && (window?.Config as any)?.codeType === 'brand'
  let info = {
    tableCode: '',
    tableTent: '',
    kids: 0,
    remark: '',
    person: restaurantCenter.config.shouldDispPersonModal === true ? 0 : 1,
    startTimeOffset: 0,
    payMode: payMode || 0 as 0 | 1,
    isTogo: 0 as 0 | 1, // 购物车上有全局的标志位
    startTime: '',
    menuTime: '',
    asapTime: '',
    eatType: eatType || (noEatType ? '' : 'dinein') as TEatType, // 购物车当前用餐模式
    freeTaxList: [],
    cityId: 0,
    seatInfo: null,
    openBySeat: false,
  }

  // 手机点餐 需要把storage就餐人数填入购物车
  try {
    if ((window?.Config as any)?.RESTAURANTAPP === 'mobile') {
      const personData = store.get(`ls.diningPerson.${window?.Config.BRANDID}.${window?.Config.STOREID}`) || { person: 0, kids: 0 }
      /** 就餐人数缓存未过期 */
      if (personData?.expired && personData?.expired > Date.now()) {
        info = { ...info, ...personData }
      }
    }
  } catch (error) {
  }
  return info
}

type TViewItem = IViewCartItem | IViewOrderDetail
// type TViewCombinedItem = IViewCombinedCartItem | IViewCombinedOrderDetail;
type TReturnTViewCombinedItem<T> = T extends IViewCartItem ? IViewCombinedCartItem : IViewCombinedOrderDetail

function combineItem<T extends TViewItem> (items: T[]): TReturnTViewCombinedItem<T>[] {
  const combinedCartItems: TReturnTViewCombinedItem<T>[] = []
  items.forEach(viewCartItem => {
    const fkey = viewCartItem.fkey.replace(/_[^_]*$/, '')
    const addTime = (viewCartItem as any)?.addTime
    const theCartItem = combinedCartItems.find(item => {
      if ((item as IViewCombinedOrderDetail).refundCnt) {
        return false
      } else if (item.fkey === fkey && (item as any).addTime === addTime) {
        // fkey相同 且 下单时间相同
        return true
      }
    }) as TReturnTViewCombinedItem<T>
    if (theCartItem && theCartItem.type === 'product') {
      theCartItem.pks.push(viewCartItem.pk)
      // 订单时可能会是多笔餐品同一个人下单
      if (!theCartItem.addUsers.includes(viewCartItem.addUserId)) {
        theCartItem.addUsers.push(viewCartItem.addUserId)
      }
      const combinedKeys = ['actualPrice', 'cnt', 'offPrice', 'productPrice', 'realPrice', 'realPriceWithTax', 'tax', 'totalActualPrice', 'totalPrice', 'totalPriceWithTax', 'totalProductPrice', 'totalTax']
      combinedKeys.forEach(key => {
        (theCartItem as any)[key] = toDecimal((theCartItem as any)[key] + (viewCartItem as any)[key])
      })
      // 合并优惠显示
      if (theCartItem.offItems?.length) {
        viewCartItem.offItems?.forEach(offItem => {
          const theOffItem = theCartItem.offItems?.find(off => off.offTip === offItem.offTip && off.offType === offItem.offType)
          if (theOffItem) {
            theOffItem.off = toDecimal(theOffItem.off + offItem.off)
          } else {
            theCartItem.offItems?.push(offItem)
          }
        })
      } else {
        if (viewCartItem.offItems) {
          theCartItem.offItems = [...viewCartItem.offItems]
        }
      }
      if (theCartItem.swapBuyProducts?.length) {
        theCartItem.swapBuyProducts = (theCartItem.swapBuyProducts as IViewCartItem[]).concat(viewCartItem.swapBuyProducts as IViewCartItem[])
      }
      if (theCartItem.fullItemNFreeProducts?.length) {
        theCartItem.fullItemNFreeProducts = (theCartItem.fullItemNFreeProducts as IViewCartItem[]).concat(viewCartItem.fullItemNFreeProducts as IViewCartItem[])
      }
    } else {
      combinedCartItems.push({
        ...omit(viewCartItem, ['pk', 'addUserId']),
        fkey,
        pks: [viewCartItem.pk],
        addUsers: [viewCartItem.addUserId]
      } as any)
    }
  })
  return combinedCartItems
}

function getViewItems (items: ICartItem[], extInfo?: { isTogo?: 0 | 1; inCombo?: boolean; inSwapBuy?: boolean; hasScale?: boolean; cntMap?: {[no: string]: number} }): IViewCartItem[] {
  const scaleNoToCntMap = productSaleMobx.scaleNoToCntMap
  const productNoToCntMap = productSaleMobx.menuProductNoToCntMap
  // 记录每个餐品在购物车内的总数用于最低限售
  const cntMap = extInfo?.cntMap || {}
  return items.map((item: ICartItem) => {
    const viewOrderCart = orderMobx.ordersCartMap[item.pk] // 购物车下单确认还原
    const viewProduct = productMobx.noToViewProductMap[item.productNo] // 菜单
    const productNo = viewOrderCart?.productNo || viewProduct?.no
    const productName = viewOrderCart?.productName || viewProduct?.name || item.name
    const maxSalesCnt = viewProduct?.maxSalesCnt || 0
    const noCnt = cntMap[item.productNo] || 0
    let disabledReason = ''
    let disabled = extInfo?.inCombo ? false : !viewProduct
    if (disabled && viewOrderCart) {
      disabled = false
    }
    if (disabled) {
      disabledReason = TCartitemDisabledReason.EXPIRED
    }
    disabled = extInfo?.inCombo ? false : (disabled || (!viewOrderCart && !viewProduct.isNotSingleInCombo) || productNoToCntMap[productNo]?.cnt === 0 || scaleNoToCntMap[`${productNo}_${item.scaleNo}`]?.cnt === 0)
    if (disabled) {
      disabledReason = disabledReason || TCartitemDisabledReason.SOLDOUT
    }
    // 有可能餐品已经失效，所以不能以viewProduct作为必要数据
    const scale = (viewProduct && viewProduct.scales.find((s: IScale) => s.no === item.scaleNo)) || { price: 0, togoFee: 0, name: '', modifierGroups: null, productPrice: (item as any).productPrice, isOpenPrice: 0, status: '' }
    // 规格下架case
    if ((!scale || !(scale as IScale).no) && !disabled && !viewOrderCart) {
      disabled = true
      disabledReason = TCartitemDisabledReason.EXPIRED
    }
    // 规格不在套餐内，并且不可单卖
    if (!disabled && scale && !extInfo?.inCombo && scale.status === 'disable') {
      disabled = true
      disabledReason = TCartitemDisabledReason.EXPIRED
    }
    if (!disabled && extInfo?.isTogo === 1 && !extInfo.inCombo && item.isCanTogo === false) {
      disabled = true
      disabledReason = TCartitemDisabledReason.CANNOTTOGO
    }
    // 当前规格是时价判断售罄条件
    if (restaurantConfig.hideOpenPriceProduct && !disabled && scale?.isOpenPrice) {
      disabled = true
    }
    const name = productName
    const scaleName = (disabledReason === TCartitemDisabledReason.EXPIRED ? item.scaleName : scale.name) || ''
    // 口味组有可能是餐品级的 也有可能是规格级的
    const useModifierGroups = scale?.modifierGroups || viewProduct?.modifierGroups || item.modifierGroups
    const modifierGroups = convertModifierGroupsToDoModifierGroups(productNo, useModifierGroups, item.modifierGroups)
    let { modifierStr, modifierHtml, modifierPrice, modifierDisabled } = getModifierStrAndModifierPrice(modifierGroups, useModifierGroups)
    // 当前购物车口味加料不在菜单里面手机端判断售罄
    const modifierGroupsDisabled = restaurantConfig.app === 'mobile' && checkCartModifierNotInMenu(useModifierGroups, item.modifierGroups)
    if (!disabled && (modifierDisabled || modifierGroupsDisabled)) {
      disabled = true
      disabledReason = TCartitemDisabledReason.EXPIRED
    }
    /** 超过限售数量 */
    if (restaurantConfig.app !== 'pos' && !item.isOrderSwapBuy && !extInfo?.inSwapBuy && !disabled && maxSalesCnt && noCnt > maxSalesCnt) {
      disabled = true
      disabledReason = TCartitemDisabledReason.MAXSALESCNT
    }
    // 当前规格加口味变成了 一组option的形式放到了购物车中
    let optionStr = modifierStr || ''
    let optionHtml = modifierHtml
    if (scaleName) {
      optionStr = modifierStr && scaleName ? [scaleName, modifierStr].join(', ') : scaleName || modifierStr
      optionHtml = modifierHtml && scaleName ? modifierHtml.replace('<span>', '<span>' + scaleName + ', ') : modifierHtml || `<span>${scaleName}</span>`
    }
    // 整单换购餐品失效
    if (item.isOrderSwapBuy && (!discountMobx.allOrderSwapBuyActityProductsMap?.[item.pk] || discountMobx.allOrderSwapBuyActityProductsMap?.[item.pk]?.orderSwapBuyStatus === 'ineffective')) {
      disabled = true
      disabledReason = TCartitemDisabledReason.ORDERSWAPBUYINEFFECTIVE
    }
    // 单品换购餐品失效
    if (extInfo?.inSwapBuy && item.parentPk && !discountMobx.singleSwapBuyValidProductPkMap?.[item.pk]) {
      disabled = true
      disabledReason = TCartitemDisabledReason.SINGLESWAPBUYINEFFECTIVE
    }
    // 换购
    let swapBuyProducts: any
    if (item?.swapBuyProducts?.length && !restaurantConfig.buyTogetherId) {
      swapBuyProducts = getViewItems(item.swapBuyProducts, { ...(extInfo || {}), inSwapBuy: true }) as IViewCartItem[]
    }
    // 满送
    let fullItemNFreeProducts: any
    if (item?.fullItemNFreeProducts?.length && !restaurantConfig.buyTogetherId) {
      fullItemNFreeProducts = getViewItems(item.fullItemNFreeProducts, extInfo) as IViewCartItem[]
    }
    // 套餐
    let isCanTogo = item.isCanTogo !== undefined ? item.isCanTogo : viewProduct?.isCanTogo
    let addPrice = item.addPrice || 0
    let productGroups: any
    let productGroupsBoxPrice = 0
    // let optionAddPriceMap: any = {};
    if (item.productGroups?.length) {
      productGroups = item.productGroups.map(group => {
        const isTogo = item.isTogo || extInfo?.isTogo || 0
        const productGroupDetails = getViewItems(group.productGroupDetails, { isTogo, inCombo: true, hasScale: group.productGroupDetails.some(i => isEmpty(i?.scaleName)) }) as IViewComboCartItem[]
        // 自选套餐加价价格按一份处理，不加多份
        addPrice += productGroupDetails.reduce((p: number, s) => {
          return p + ((s?.addPrice || 0))
        }, 0)
        // 套餐加料价格(餐品合计)
        modifierPrice += productGroupDetails.reduce((p: number, s) => {
          return p + (s.modifierPrice * s.cnt)
        }, 0)
        // 套餐打包费(餐品合计)
        productGroupsBoxPrice += productGroupDetails.reduce((p: number, s) => {
          return p + s.totalBoxPrice
        }, 0)
        return { ...group, productGroupDetails }
      })
      isCanTogo = productGroups.every((group: any) => group?.productGroupDetails.every((product: any) => !!product.isCanTogo))
      // 购物车套餐子餐品估清，套餐估清
      const childSoldout = productGroups.some((group: any) => group?.productGroupDetails.some((product: any) => productNoToCntMap[product.productNo]?.cnt === 0 || scaleNoToCntMap[`${product.productNo}_${product.scaleNo}`]?.cnt === 0 || product.disabled))
      if (childSoldout) {
        disabled = true
        disabledReason = TCartitemDisabledReason.SOLDOUT
      }
    }
    let startTime: string = item.startTime || ''
    let pickTimeRange: string = item.pickTimeRange || ''
    // 这边需要额外注意只有openPrice才会在item上附带有price
    let _productPrice = (item.price || scale?.price || (scale as any)?.productPrice || 0)
    if (viewOrderCart) {
      if (viewOrderCart.addPrice !== undefined && viewOrderCart.addPrice !== null) {
        addPrice = viewOrderCart.addPrice
      }
      _productPrice = (viewOrderCart.originalFee - (addPrice || 0)) / (viewOrderCart.cnt || 1)
      startTime = viewOrderCart?.startTime || ''
      pickTimeRange = viewOrderCart?.pickTimeRange || ''
    }
    if (typeof (item.openPriceX) !== 'undefined' && item.openPriceX !== -1) {
      _productPrice = item.openPriceX
    }
    const price = item.price ? item.price + addPrice : addPrice
    const productPrice = _productPrice + addPrice
    const unitPrice = modifierPrice + productPrice
    const tax = feeMobx.pkToTax[item.pk] || 0
    const freeTax = feeMobx.pkToFreeTax[item.pk] || 0
    const unitTax = toDecimal(tax / item.cnt, 7)
    const unitBoxPrice = toDecimal(item.productGroups?.length ? (productGroupsBoxPrice || 0) : (scale.togoFee || 0), 7)
    const unitPriceWithTax = unitPrice + tax
    const unitAddPrice = addPrice
    // TODO 需要对一下这个数据的正确性
    const totalTax = tax // * item.cnt
    const totalFreeTax = freeTax
    const totalProductPrice = toDecimal(productPrice * item.cnt)
    const totalPrice = toDecimal(unitPrice * item.cnt)
    const totalPriceWithTax = toDecimal(totalPrice + totalTax)
    const totalAddPrice = toDecimal(unitAddPrice * item.cnt)
    const isTogo = item.isTogo || extInfo?.isTogo || 0
    const totalBoxPrice = isTogo ? toDecimal(unitBoxPrice * item.cnt) : 0
    // 优惠对接
    const itemDiscountInfo = discountMobx.discountResult.itemMap[item.pk]
    let offPrice = 0
    let apportionOffPrice = itemDiscountInfo && itemDiscountInfo.apportion ? itemDiscountInfo.apportion.off : 0
    const offItems = itemDiscountInfo && itemDiscountInfo.items ? itemDiscountInfo.items.map(offInfo => {
      offPrice += offInfo.off
      return {
        offTip: offInfo.offTip,
        off: offInfo.off,
        offType: offInfo.offType
      }
    }) : []
    const offItemPlan = itemDiscountInfo && itemDiscountInfo.items ? itemDiscountInfo.items.find(offItem => offItem.offType === 'plan') : null
    const offItemPlanTagId = offItemPlan ? offItemPlan.tagId || 0 : 0
    const actualPrice = toDecimal(totalPrice - offPrice)
    // const apportionOffPrice = apportionOffPrice
    const realPrice = toDecimal(actualPrice - apportionOffPrice)
    // 未下单的餐品实际的价格就是未退的价格
    const totalActualPrice = totalPrice
    const unitRealPrice = toDecimal(realPrice / item.cnt)
    const unitRealPriceWithTax = toDecimal(unitRealPrice + unitTax, 7)
    const realPriceWithTax = toDecimal(realPrice + totalTax, 7)
    const pic = viewProduct ? viewProduct.pic : ((item as any).pic || '')
    const categories = viewProduct ? viewProduct.categories : []
    const statisticsCategoryNo = viewProduct ? viewProduct.statisticsCategoryNo : ''
    const allergys = viewProduct?.allergys || []
    const tags = viewProduct?.tags || []
    return {
      ...item,
      modifierStr,
      optionStr,
      extInfo,
      price,
      productPrice,
      totalActualPrice,
      totalProductPrice,
      totalAddPrice,
      modifierPrice,
      unitPrice,
      tax,
      unitPriceWithTax,
      totalPrice,
      totalTax,
      totalPriceWithTax,
      isTogo,
      isCanTogo,
      unitBoxPrice,
      totalBoxPrice,
      disabled,
      disabledReason,
      modifierHtml,
      optionHtml,
      offPrice,
      offItems,
      actualPrice,
      apportionOffPrice,
      realPrice,
      unitTax,
      unitRealPrice,
      unitRealPriceWithTax,
      unitAddPrice,
      realPriceWithTax,
      pic,
      categories,
      allergys,
      tags,
      statisticsCategoryNo,
      modifierGroups,
      scaleName,
      name,
      freeTax,
      totalFreeTax,
      offItemPlanTagId,
      // 换购餐品组
      swapBuyProducts,
      // 套餐组
      productGroups,
      itemInfoBackup: { ...item },
      fullItemNFreeProducts,
      // 手机后付费对接：餐品预约时间 / 取餐时间
      startTime,
      pickTimeRange
    }
  })
}

/**
 * 合并套餐内相同加料的商品
 */
function mergeProductGroupModifier (groups: IViewComboCartItem[]) {
  let fkeyGroup = groupBy(groups, 'fkey')
  return Object.keys(fkeyGroup).map((key) => {
    const cnt = sumBy(fkeyGroup[key], (i) => i.cnt)
    const addPrice = sumBy(fkeyGroup[key], (i) => (i?.addPrice || 0))
    return {
      ...fkeyGroup[key][0],
      cnt,
      addPrice
    }
  })
}

function getOrderDetails<T extends IViewCartItem> (cartResult: ICartResult, viewCartItems: T[], info: ICartInfo): ISaveCartItem[] {
  let items = [] as ISaveCartItem[]
  let isTogo = cartResult.isTogo
  viewCartItems
    .filter(item => item.cnt && !item.disabled)
    .forEach(cartItem => {
      const item = {
        cnt: cartItem.cnt,
        productModifierGroup: cartItem.modifierGroups.map(modifierGroup => {
          return {
            productModifierGroupNo: modifierGroup.no,
            productModifier: modifierGroup.modifiers.filter(modifier => modifier.cnt || modifier.isDefault).map(modifier => {
              return {
                cnt: modifier.cnt,
                productModifierNo: modifier.no,
                productModifierName: modifier.name,
                originalFee: modifier.price
              }
            })
          }
        }).filter(modifierGroup => modifierGroup.productModifier.length),
        productNo: cartItem.productNo,
        isTogo: isTogo || cartItem.isTogo,
        originalFee: cartItem.totalProductPrice,
        paidFee: cartItem.totalProductPrice,
        box: cartItem.totalBoxPrice,
        offItems: cartItem.offItems, // 实际用于核对使用
        productName: cartItem.name,
        productScaleNo: cartItem.scaleNo,
        startTime: cartItem.startTimeOffset ? ddayjs(cartItem.startTime || info.startTime).add(cartItem.startTimeOffset, 'm').format() : cartItem.startTime || info.startTime || null, // cartItem.startTime,
        pickTimeRange: cartItem.pickTimeRange,
        type: cartItem.type,
        pk: cartItem.pk,
        remark: cartItem.remark,
        startTimeOffset: cartItem.startTimeOffset,
        addUserId: cartItem.addUserId,
        addUserName: cartItem.addUserName?.substring(0, 50),
        addUserAvatar: cartItem.addUserAvatar,
        isTaxFree: cartItem.isTaxFree ? 1 : 0,
        addPrice: cartItem.addPrice
      } as ISaveCartItem
      if (cartItem.isOrderSwapBuy) {
        item.ordersHuangou = 1
      }
      if (cartItem.swapBuyProducts?.length) {
        item.huangou = getOrderDetails(cartResult, cartItem.swapBuyProducts, {
          ...info,
          startTime: item.startTime || info.startTime,
        })
      }
      if (cartItem.fullItemNFreeProducts?.length) {
        item.zengsong = getOrderDetails(cartResult, cartItem.fullItemNFreeProducts, {
          ...info,
          startTime: item.startTime || info.startTime,
        })
      }
      if (cartItem.productGroups?.length) {
        item.productGroups = cartItem.productGroups?.map(group => {
          const { name, productNo, selectMin, selectMax, productGroupDetails } = group
          const saveItem = {
            name,
            productGroupNo: group.no || group.productGroupNo,
            productNo,
            selectMin,
            selectMax,
            productGroupDetails: getOrderDetails(cartResult, productGroupDetails, {
              ...info,
              startTime: item.startTime || info.startTime,
            })
          }
          return saveItem as ISaveCartProductGroup
        })
      }
      if (info.openBySeat && info.tableCode) {
        item.seat = cartItem.seat
      }
      if (typeof (cartItem.openPriceX) !== 'undefined' && cartItem.openPriceX !== -1) {
        item.openPriceX = cartItem.openPriceX
      }
      items.push(item)
    })
  return unionBy(items, 'pk')
}

// 减少单品换购餐品
function reduceSwapBuy ({ swapBuyProducts, start, length }: { swapBuyProducts?: any[]; start?: number; length?: number }) {
  return swapBuyProducts?.length ? sortBy([...swapBuyProducts].splice(start || 0, length), 'timestamp') : undefined
}

// 将订单中的餐品还原回购物车的统一转换方法
function convertOrderItemToCartItem (orderItem: IViewOrderDetail): ICartItem {
  const modifierGroups = convertDoModifierGroupsToModifierGroups(orderItem.modifierGroups)
  const productGroups = orderItem.productGroups?.map(group => {
    const productGroupDetails = group.productGroupDetails.map(convertOrderItemToCartItem)
    return { ...group, productGroupDetails } as IComboCartGroup
  })
  const swapBuyProducts = orderItem.swapBuyProducts?.map(convertOrderItemToCartItem)
  const fullItemNFreeProducts = orderItem.fullItemNFreeProducts?.map(convertOrderItemToCartItem)
  const isCombo = ['FixedCombo', 'OptionalCombo'].includes(orderItem.type)
  return {
    type: orderItem.type,
    productNo: orderItem.productNo,
    name: orderItem.name,
    cnt: orderItem.cnt,
    remark: orderItem.remark,
    fkey: orderItem.pk,
    startTimeOffset: 0,
    pk: orderItem.pk,
    scaleNo: orderItem.scaleNo,
    scaleName: orderItem.scaleName,
    isTogo: orderItem.isTogo,
    isSingleSale: productMobx.noToViewProductMap[orderItem.productNo] ? productMobx.noToIsSingleSaleViewProductMap[orderItem.productNo]?.isSingleSale : true,
    modifierGroups,
    productGroups,
    swapBuyProducts,
    fullItemNFreeProducts,
    odetailId: orderItem.detailId,
    addUserId: orderItem.addUserId,
    addUserName: orderItem.addUserName,
    addUserAvatar: orderItem.addUserAvatar,
    isTaxFree: orderItem.isTaxFree,
    addPrice: isCombo ? undefined : (orderItem?.addPrice || orderItem?.productExt?.addPirce)
  }
}

// 将未接单的订单(其中可能包含未接单的餐品)还原回购物车的统一转换方法
function convertSaveItemToCartItem (saveItem: ISaveCartItem): ICartItem {
  const modifierGroups = saveItem.productModifierGroup.map(productMG => ({
    no: productMG.productModifierGroupNo,
    modifiers: productMG.productModifier.map(pm => ({
      name: pm.productModifierName,
      no: pm.productModifierNo,
      cnt: pm.cnt,
      price: pm.originalFee
    }))
  }))
  const swapBuyProducts = saveItem.huangou?.map(convertSaveItemToCartItem)
  const productGroups = saveItem.productGroups?.map(group => {
    const productGroupDetails = group.productGroupDetails.map(convertSaveItemToCartItem)
    return { ...group, productGroupDetails } as IComboCartGroup
  })
  const fullItemNFreeProducts = saveItem.zengsong?.map(convertSaveItemToCartItem)
  return {
    type: saveItem.type,
    productNo: saveItem.productNo,
    name: saveItem.productName,
    cnt: saveItem.cnt,
    remark: saveItem.remark,
    startTimeOffset: 0,
    pk: saveItem.pk,
    scaleNo: saveItem.productScaleNo,
    scaleName: '',
    isTogo: saveItem.isTogo,
    isSingleSale: productMobx.noToViewProductMap[saveItem.productNo] ? productMobx.noToIsSingleSaleViewProductMap[saveItem.productNo]?.isSingleSale : true,
    modifierGroups,
    addUserId: saveItem.addUserId,
    addUserName: saveItem.addUserName,
    addUserAvatar: saveItem.addUserAvatar,
    isTaxFree: !!saveItem.isTaxFree,
    fkey: createFkey({ productNo: saveItem.productNo, scaleNo: saveItem.productScaleNo, modifierGroups, addUserId: saveItem.addUserId, isTogo: saveItem.isTogo, startTime: saveItem.startTime || undefined, isSeat: saveItem.seat || '-1', isOrderSwapBuy: saveItem.isOrderSwapBuy, productGroups, openPriceX: saveItem.openPriceX }),
    swapBuyProducts,
    productGroups,
    fullItemNFreeProducts,
    addPrice: saveItem?.addPrice,
    isOrderSwapBuy: !!saveItem.ordersHuangou,
    isOrdersCart: true
  }
}

// 检查口味加料是否‘不存在’当前菜单餐品内，覆盖场景=>下单付款时有加料，之后再来一单前改过加料，产品定义加料项不存在属于售罄
function checkCartModifierNotInMenu (modifierGroups: IModifierGroup[], cartModifierGroups: ICartModifierGroup[]) {
  const menuModifierNoAndGroupNo: string[] = [] // 结构['groupNo_no1', 'groupNo_no2']
  forEach(modifierGroups, (item) => {
    const groupNo = item.no
    forEach(item.modifiers, (modifer) => {
      const modiferNo = modifer.no
      menuModifierNoAndGroupNo.push(`${groupNo}_${modiferNo}`)
    })
  })
  return some(cartModifierGroups, (item) => {
    const groupNo = item.no
    return some(item.modifiers, (modifier) => {
      const mKey = `${groupNo}_${modifier.no}`
      return !menuModifierNoAndGroupNo.includes(mKey)
    })
  })
}

// 处理购物车缓存数据
function resetRestoreCartItems (info: any, cartItems: ICartItem[] | IComboCartItem[]) {
  if (!cartItems?.length) return []
  return cloneDeep(cartItems)?.map((item: ICartItem) => {
    item.isSingleSale = productMobx.noToViewProductMap[item.productNo] ? productMobx.noToIsSingleSaleViewProductMap[item.productNo]?.isSingleSale : true
    if (info?.eatType !== 'dinein') {
      item.isTogo = 1
    }
    if (restaurantConfig.app === 'mobile' && restaurantConfig.codeType !== 'brand') {
      delete item.startTime
      delete item.pickTimeRange
    }
    // 满赠
    if (item.fullItemNFreeProducts?.length) {
      item.fullItemNFreeProducts = resetRestoreCartItems(info, item.fullItemNFreeProducts)
    }
    // 换购
    if (item.swapBuyProducts?.length) {
      item.swapBuyProducts = resetRestoreCartItems(info, item.swapBuyProducts)
    }
    // 套餐
    if (item.productGroups?.length) {
      item.productGroups = item.productGroups?.map(group => {
        group.productGroupDetails = resetRestoreCartItems(info, group.productGroupDetails) as IComboCartItem[]
        group.productGroupDetails.forEach(detail => {
          const comboGroup = productMobx.noToViewProductMap?.[item.productNo]?.productGroups?.find(g => g.no === group.no)
          const productDetail = comboGroup?.productGroupDetails?.find(d => d.productNo === detail.productNo && d.scaleNo === detail.scaleNo)
          detail.addPrice = productDetail ? productDetail.addPrice : detail.addPrice
        })
        return group
      })
    }
    return item
  })
}

// 替换购物项
function replaceCartItem (cartItem: ICartItem) {
  let item = cloneDeep(cartItem)
  // 套餐
  if (item.productGroups?.length) {
    item.productGroups = item.productGroups?.map(group => {
      group.productGroupDetails = group.productGroupDetails?.map(detail => {
        return replaceCartItem(detail) as IComboCartItem
      })
      return group
    })
  }
  // 满赠
  if (item.fullItemNFreeProducts?.length) {
    item.fullItemNFreeProducts = item.fullItemNFreeProducts?.map(fullItem => {
      return replaceCartItem(fullItem)
    })
  }
  // 换购
  if (item.swapBuyProducts?.length) {
    item.swapBuyProducts = item.swapBuyProducts?.map(swapItem => {
      return replaceCartItem(swapItem)
    })
  }
  item.addUserId = restaurantConfig?.member?.key || ''
  item.addUserName = restaurantConfig?.member?.nickName || ''
  item.addUserAvatar = restaurantConfig?.member?.avatar || ''
  item.pk = doPk()
  item.fkey = createFkey({ productNo: item.productNo, scaleNo: item.scaleNo, modifierGroups: item.modifierGroups, addUserId: item.addUserId, isTogo: item.isTogo, startTime: item.startTime, isSeat: item.seat || '-1', isOrderSwapBuy: item.isOrderSwapBuy, productGroups: item.productGroups, openPriceX: item.openPriceX, price: item.price })
  return item
}

// 批量替换购物项pk
function replaceCartItemPk (cartItem: ICartItem) {
  const _cartItem = cloneDeep(cartItem)
  const _pk = doPk()
  _cartItem.pk = _pk
  _cartItem.swapBuyProducts?.forEach(item => {
    item.parentPk = _pk
    item.pk = doPk()
    if (item?.productGroups?.length) {
      item.productGroups?.forEach(group => {
        group.productGroupDetails?.forEach(product => {
          product.pk = doPk()
        })
      })
    }
  })
  _cartItem.fullItemNFreeProducts?.forEach(item => {
    item.parentPk = _pk
    item.pk = doPk()
    if (item?.productGroups?.length) {
      item.productGroups?.forEach(group => {
        group.productGroupDetails?.forEach(product => {
          product.pk = doPk()
        })
      })
    }
  })
  _cartItem.productGroups?.forEach(group => {
    group.productGroupDetails?.forEach(product => {
      product.pk = doPk()
    })
  })
  return _cartItem
}

/** 点餐购物车Mobx */
class Cart {
  constructor () {
    makeAutoObservable(this)
    restaurantCenter.on([
      RESTAURANT_EVENT.CART_ITEMS_CHANGED,
      RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED,
      RESTAURANT_EVENT.MENU_END
    ], () => {
      /** 切换预约时间，可能会售罄 */
      if (this.info.eatType === 'delivery') {
        this.setExpressList()
      }
    })
  }

  isUpdateContact: boolean = false

  debug = false

  /** 购物车的标记由购物车信息组成 cartItems & info */
  lastHash = ''

  /** 当前购物车同时存在的订单的ID */
  ordersId: string = ''

  /** 基础的购物车项 */
  cartItems: ICartItem[] = []
  /** 满赠商品在购物车底部展示 */
  // mergeFullItemNFree:Array<ICartItem[]|string> = []

  /** 暂存购物车 */
  cacheCartItems: ICartItem[] = []

  /** 基础的购物信息 */
  info: ICartInfo = getCartInitialInfo()

  /** 购物车仓库，用于暂存（挂单/取单） */
  cartDepot: ICartCopy[] = []

  /** 特殊的标记位主要用于隔离是否已下单未下单混杂计算，默认开启 */
  isMixture = true

  /** 标记后付费场景: 待接单订单处理 => 拒绝加菜标记清空加菜购物车 默认:false */
  isReject = false

  /** 选择了打包的餐品fkeys */
  cartPackFkeys: { [key: string]: number } = {}

  /** 是否需要打包 */
  needPack: boolean = false

  /** 订单合并展示 */
  orderMerge: boolean = false

  /** POS订单手机支付 */
  posOrderPay: boolean = false

  /** 能否单独下单(含不能单独下单餐品时) */
  get canSingleSale (): boolean {
    if (this.viewOrderItems?.length) {
      return true
    }
    return this.viewCartItems?.length ? some(this.viewCartItems, item => {
      return !item.disabled && (item.isSingleSale || some(item?.swapBuyProducts, i => i.isSingleSale) || some(item?.fullItemNFreeProducts, i => i.isSingleSale))
    }) : true
  }

  /** productNo为key统计加入购物车的数量 */
  get noToCartItemsCntMap () {
    const map: any = {}
    forEach(this.cartItems, (item) => {
      map[item.productNo] = (map[item.productNo] || 0) + item.cnt
    })
    forEach(this.viewOrderItems, (item) => {
      if (item.channel !== 'pos') {
        map[item.productNo] = (map[item.productNo] || 0) + item.cnt
      }
    })
    return map
  }

  /** 预约时间 根据startTime去重 asapTime 当前时间 */
  get cartStartTimes (): string[] {
    /** 订单级预约时间 */
    const orderTime = this.info.startTime || this.info.asapTime
    /** 以预约时间为key */
    const startTimeMap: { [key: string]: any } = {}
    /** 开启预约点单 */
    const isMobileBookingOrder = storeMobx.info.isMobileBookingOrder
    // 未开通预约，因为购物车单项不会清除startTime, 需要忽略多笔配送
    if (isMobileBookingOrder) {
      forEach(this.viewCartItems, (item) => {
        if (!item.disabled) {
          if (orderTime && !item.startTime && !startTimeMap[orderTime]) {
            startTimeMap[orderTime] = true
          }
          if (item.startTime && !startTimeMap[item.startTime]) {
            startTimeMap[item.startTime] = true
          }
          /** 换购 */
          forEach((item.swapBuyProducts || []), (freeItem) => {
            if (freeItem.startTime && !startTimeMap[freeItem.startTime]) {
              startTimeMap[freeItem.startTime] = true
            }
          })
        }
      })
      const startTimes: any[] = Object.keys(startTimeMap)
      return startTimes.length ? startTimes : [orderTime]
    } else {
      return [orderTime] as any
    }
  }

  /** 计算后的购物车项(业务视图中使用此项) */
  get viewCartItems (): IViewCartItem[] {
    if (!this.isMixture && orderMobx.order.status !== 'NotAccepted') {
      return []
    }
    if (this.isReject && orderMobx.order.status === 'NotAccepted') {
      // 后付费待接单订单拒绝加菜
      return []
    }
    return getViewItems(this.cartItems, { isTogo: this.info?.eatType !== 'dinein' ? 1 : 0, cntMap: this.noToCartItemsCntMap })
  }

  /** 购物车视图项 合并满赠 */
  get viewMergeFullItemNFree (): Array<IViewCartItem[] | string | undefined> {
    return flatten(this.viewCartItems.map(i => [i.fullItemNFreeProducts, i.lackFullItemNFreeProducts].filter((i) => !isEmpty(i))))
  }

  /** 购物车视图项 用户分组展示 */
  get viewUserCartItems () {
    return groupBy(this.viewCartItems, 'addUserId')
  }

  /** 购物车视图项 用户展示 */
  get viewUserCartUsers () {
    return sortBy(Object.keys(cartMobx.viewUserCartItems), user => user === restaurantConfig?.member?.key ? 0 : 1)
  }

  /** 购物车视图项 用户的差异分离聚合 */
  get viewCombinedCartItems () {
    return combineItem(this.viewCartItems)
  }

  /** 计算后的购物车不可用项 （仅业务层视图使用此项） */
  get viewDisabledCartItems (): IViewCartItem[] {
    return this.viewCartItems.filter(item => item.disabled)
  }

  /** 经过判断后的已下的订单的数据，实际是从orderMobx过来的值 */
  get viewOrderItems (): IViewOrderDetail[] {
    if (orderMobx && orderMobx.order.ordersId === this.ordersId && (this.info.payMode || this.posOrderPay)) {
      return orderMobx.viewDetailList.filter(viewDetail => !viewDetail.isWait && viewDetail.originalCnt).map(viewDetail => {
        // 优惠对接
        const itemDiscountInfo = discountMobx.discountResult.itemMap[viewDetail.pk]
        let offPrice = 0
        let apportionOffPrice = itemDiscountInfo && itemDiscountInfo.apportion ? itemDiscountInfo.apportion.off : 0
        const offItems = itemDiscountInfo && itemDiscountInfo.items ? itemDiscountInfo.items.map(offInfo => {
          offPrice += offInfo.off
          return {
            offTip: offInfo.offTip,
            off: offInfo.off,
            offType: offInfo.offType,
          }
        }) : []
        const offItemPlan = itemDiscountInfo && itemDiscountInfo.items ? itemDiscountInfo.items.find(offItem => offItem.offType === 'plan') : null
        const offItemPlanTagId = offItemPlan ? offItemPlan.tagId || 0 : 0
        const tax = feeMobx.pkToTax[viewDetail.pk] || viewDetail.tax
        const totalTax = toDecimal(tax, 7)
        const unitTax = viewDetail.cnt ? toDecimal(totalTax / viewDetail.cnt, 7) : 0
        const actualPrice = toDecimal(viewDetail.totalPrice - offPrice)
        const totalActualPrice = actualPrice
        const unitAddPrice = toDecimal((viewDetail.addPrice || 0))
        const totalAddPrice = toDecimal((viewDetail.addPrice || 0) * viewDetail.cnt)
        // const apportionOffPrice = discountMobx.discountResult.apportion[viewDetail.pk] ? discountMobx.discountResult.apportion[viewDetail.pk].off : 0
        const realPrice = toDecimal(actualPrice - apportionOffPrice)
        const unitRealPrice = toDecimal(realPrice / viewDetail.cnt)
        const unitRealPriceWithTax = toDecimal(unitRealPrice + unitTax, 7)
        const realPriceWithTax = toDecimal(realPrice + totalTax, 7)
        const allergys = (allMenuMobx.noToViewProductMap[viewDetail.productNo] || allMenuMobx.noToViewProductMap[viewDetail.productNo])?.allergys || []
        const tags = (allMenuMobx.noToViewProductMap[viewDetail.productNo] || allMenuMobx.noToViewProductMap[viewDetail.productNo])?.tags || []
        // TODO: 税分类ID
        const taxCategoryId = productMobx.noToViewProductMap[viewDetail.productNo]?.taxCategoryId || viewDetail.taxCategoryId || 0
        /** 已下订单的餐品的税以再次计算的结果为准 */
        const isZS = restaurantConfig.app === 'pos' && viewDetail.productGroupNo === 'zengsong'
        const fkey = createFkey({ productNo: viewDetail.productNo, scaleNo: viewDetail.scaleNo, modifierGroups: viewDetail.modifierGroups, addUserId: viewDetail.addUserId, isTogo: viewDetail.isTogo, startTime: viewDetail.startTime, isSeat: viewDetail.seat || '-1', isOrderSwapBuy: viewDetail.isOrderSwapBuy })
        const isAllRefund = !!(viewDetail.refundCnt && viewDetail.refundCnt === viewDetail.originalCnt)
        const isCanTogo = productMobx.noToIsCanPackMap?.[viewDetail.productNo]
        return {
          ...viewDetail,
          isCanTogo,
          tax,
          unitTax,
          offPrice: isZS ? viewDetail.offPrice : offPrice,
          offItems: isZS ? viewDetail.offItems : offItems,
          offItemPlanTagId: isZS ? viewDetail.offItemPlanTagId : offItemPlanTagId,
          // disabled: iszs,
          actualPrice,
          totalActualPrice,
          apportionOffPrice,
          realPrice,
          unitRealPrice,
          unitRealPriceWithTax,
          realPriceWithTax,
          allergys,
          tags,
          taxCategoryId,
          fkey,
          isSingleSale: productMobx.noToViewProductMap[viewDetail.productNo] ? productMobx.noToIsSingleSaleViewProductMap[viewDetail.productNo]?.isSingleSale : true,
          unitAddPrice,
          totalAddPrice,
          isAllRefund
        }
      })
    } else {
      return []
    }
  }

  /** 订单项 用户分组展示 */
  get viewUserOrderItems () {
    return groupBy(this.viewOrderItems, 'addUserId')
  }

  /** 订单项 用户的差异分离聚合 */
  get viewCombinedOrderItems () {
    return combineItem(this.viewOrderItems)
  }

  /** 购物车视图项 可用 */
  get availableItems () {
    if (this.isMixture) {
      return [...this.viewCartItems, ...this.viewOrderItems].filter(item => item.cnt && !(item as any).disabled)
    } else {
      return this.viewOrderItems.filter(item => item.cnt && !(item as any).disabled)
    }
  }

  /** 购物车视图项 营销计算可用 */
  get availableDiscountItems () {
    if (this.isMixture) {
      return [...this.viewCartItems, ...this.viewOrderItems].filter(item => item.cnt && (!(item as any).disabled || (item as any).disabledReason === TCartitemDisabledReason.ORDERSWAPBUYINEFFECTIVE))
    } else {
      return this.viewOrderItems.filter(item => item.cnt && (!(item as any).disabled || (item as any).disabledReason === TCartitemDisabledReason.ORDERSWAPBUYINEFFECTIVE))
    }
  }

  /** 购物车视图项 打包费项 */
  get boxPriceCartItems (): IViewCartItem[] {
    const togoCartItems: IViewCartItem[] = []
    // 整单打包费展示整单数据
    if (boxFeeMobx.boxFeeType === 'ordersBoxFee') {
      return [{
        name: i18n.t('newCart.ordersBoxPrice'),
        totalBoxPrice: this.cartResult.boxPrice,
        pk: `box_${boxFeeMobx?.boxFeeConfig?.boxFeeConfigId}`
      }] as IViewCartItem[]
    }
    this.viewCartItems
      .forEach((item: IViewCartItem) => {
        item.cnt && !item.disabled && !!item.totalBoxPrice && togoCartItems.push(item)
        item?.swapBuyProducts?.forEach((swapItem: IViewCartItem) => {
          swapItem.cnt && !swapItem.disabled && !!swapItem.totalBoxPrice && togoCartItems.push(swapItem)
        })
        item?.fullItemNFreeProducts?.forEach((fullNFreeItem: IViewCartItem) => {
          fullNFreeItem.cnt && !fullNFreeItem.disabled && !!fullNFreeItem.totalBoxPrice && togoCartItems.push(fullNFreeItem)
        })
      })
    return togoCartItems
  }

  /** 购物车视图项 整单换购展示 */
  get viewOrderSwapBuyCartItems () {
    return this.viewCartItems.filter(cartItem => cartItem.isOrderSwapBuy)
  }

  /** pk到购物车视图项的map */
  get pkToViewCartItemMap () {
    return keyBy(this.viewCartItems, 'pk') as {
      [pk: string]: IViewCartItem;
    }
  }

  /** fkey到购物车视图项的map */
  get fkeyToViewCartItemMap () {
    return keyBy(this.viewCartItems, 'fkey')
  }

  /** fkey到购物车项的map */
  get fkeyToCartItemMap () {
    return keyBy(this.cartItems, 'fkey')
  }

  /** pk到可用购物车视图项的map */
  get pkToAvailableItemMap () {
    return keyBy(this.availableItems, 'pk') as {
      [pk: string]: IViewCartItem | IViewOrderDetail;
    }
  }

  /** pk到可用购物车(营销计算)视图项的map */
  get pkToAvailableDiscountItemMap () {
    return keyBy(this.availableDiscountItems, 'pk') as {
      [pk: string]: IViewCartItem | IViewOrderDetail;
    }
  }

  /** 计算后的购物概述，包括数量、价格等 */
  get cartResult (): ICartResult {
    const allProductNoToCntMap: any = {}
    const productNoToCntMap: any = {}
    const scaleNoToCntMap: { [pscaleNo: string]: number } = {}
    const allScaleNoToCntMap: { [pscaleNo: string]: number } = {}
    const categoryNoToCntMap: any = {}
    const swapBuyProductScaleNoToCntMap: any = {}
    const fullItemNFreeProductScaleNoToCntMap: any = {}
    const orderSwapBuyProductNoToCntMap: any = {}
    const orderSwapBuyProductScaleNoToCntMap: any = {}
    // (餐品 + 服务费 + 打包费 + 配送费 + 税 + 小费 - 优惠）:订单实收金额
    let totalPrice = 0
    let totalOrderPrice = 0
    let totalOrderBoxPrice = 0
    let totalCartPrice = 0
    let totalCartBoxPrice = 0
    // 当次购物车中的餐品总价
    let presentItemPrice = 0
    // 餐品原价
    let itemPrice = 0
    // 配送费 没有餐品的情况下配送费不计算
    let expressPrice = 0
    if (cartMobx.info.eatType === 'delivery') {
      expressPrice = this.availableDiscountItems?.length > 0 ? (this.info.expressList?.length ? sumBy((this.info.expressList || []), 'price') : this.info.express?.price) || 0 : 0
    }
    // 单个配送费 没有餐品的情况下配送费不计算
    // let singleExpressPrice = (this.availableDiscountItems?.length > 0 && this.info.express?.price) || 0

    // 购物车打包费
    let boxPrice = 0
    // 订单购物车打包费
    let orderBoxPrice = 0
    // 当前购物车餐品总数
    let presentTotalCnt = 0
    // 当前购物车餐品 + 已下订单中餐品的总数
    let totalCnt = 0
    // 税
    const tax = feeMobx.calculatedTaxTotal || 0
    const freeTax = feeMobx.calculatedFreeTaxTotal || 0
    const showTax = feeMobx.calculatedShowTaxTotal || 0
    // 整单优惠（包括店长折扣）
    const offItems = discountMobx.discountResult.offArr // .filter(off => off.offType !== 'coupon')
    const floorOffItem = discountMobx.discountResult.floorOff
    const integralMoneyOffItem = discountMobx.discountResult.integralMoneyOff
    const orderPlanOffItem = discountMobx.discountResult.orderPlanOff
    const discountCouponPrice = sumBy(offItems.filter(off => off.offType === 'coupon'), 'off')
    const discountActivityPrice = sumBy(offItems.filter(off => ['activity', 'ladderDiscount'].includes(off.offType)), 'off')
    let activityPrice = sumBy(offItems.filter(off => ['activity', 'ladderDiscount'].includes(off.offType)), 'off')
    let discountMemberCardPrice = sumBy(offItems.filter(off => ['memberCard', 'memberPrice'].includes(off.offType)), 'off')
    const discountPlanPrice = orderPlanOffItem?.off || 0
    const discountFloorPrice = floorOffItem?.off || 0
    const discountIntegralMoneyPrice = integralMoneyOffItem?.off || 0
    const discountPromoCodeWholePrice = sumBy(offItems.filter(off => off.offType === 'promoCode'), 'off')
    // 计算购物车项
    const calcViewCartItems = (viewCartItems: IViewCartItem[], childNode?: boolean) => {
      viewCartItems.filter(item => item.cnt && !item.disabled).forEach(item => {
        if (item.swapBuyProducts?.length) {
          item.swapBuyProducts.forEach(p => {
            swapBuyProductScaleNoToCntMap[item.pk] = swapBuyProductScaleNoToCntMap[item.pk] || {}
            const key = `${p.productNo}_${p.scaleNo}`
            const cnt = swapBuyProductScaleNoToCntMap[item.pk][key] || 0
            swapBuyProductScaleNoToCntMap[item.pk][key] = cnt + p.cnt
          })
        }
        if (item.fullItemNFreeProducts?.length) {
          item.fullItemNFreeProducts.forEach(p => {
            fullItemNFreeProductScaleNoToCntMap[item.pk] = fullItemNFreeProductScaleNoToCntMap[item.pk] || {}
            const key = `${p.productNo}_${p.scaleNo}`
            const cnt = fullItemNFreeProductScaleNoToCntMap[item.pk][key] || 0
            fullItemNFreeProductScaleNoToCntMap[item.pk][key] = cnt + p.cnt
          })
        }
        if (item.productGroups?.length) {
          item.productGroups?.forEach(p => {
            p.productGroupDetails?.forEach(d => {
              allProductNoToCntMap[d.productNo] = (allProductNoToCntMap[d.productNo] || 0) + d.cnt
              allScaleNoToCntMap[d.productNo + '_' + d.scaleNo] = (allScaleNoToCntMap[d.productNo + '_' + d.scaleNo] || 0) + d.cnt
            })
          })
        }
        totalCnt += item.disabled ? 0 : item.cnt
        presentTotalCnt += item.disabled ? 0 : item.cnt
        allProductNoToCntMap[item.productNo] = (allProductNoToCntMap[item.productNo] || 0) + item.cnt
        // 手机: 换购、满送餐品不计入菜单已点数量 2021/11/22
        if (!(restaurantCenter.config.app === 'mobile' && (childNode || item.isOrderSwapBuy))) {
          productNoToCntMap[item.productNo] = (productNoToCntMap[item.productNo] || 0) + item.cnt
        }
        if (item.isOrderSwapBuy) {
          orderSwapBuyProductNoToCntMap[`${item.productNo}`] = (orderSwapBuyProductNoToCntMap[`${item.productNo}`] || 0) + item.cnt
          orderSwapBuyProductScaleNoToCntMap[`${item.productNo}_${item.scaleNo}`] = (orderSwapBuyProductScaleNoToCntMap[`${item.productNo}_${item.scaleNo}`] || 0) + item.cnt
        }
        allScaleNoToCntMap[item.productNo + '_' + item.scaleNo] = (allScaleNoToCntMap[item.productNo + '_' + item.scaleNo] || 0) + item.cnt
        scaleNoToCntMap[item.productNo + '_' + item.scaleNo] = (scaleNoToCntMap[item.productNo + '_' + item.scaleNo] || 0) + item.cnt
        if (restaurantConfig.posAllCategories && restaurantConfig.posAllCategoriesNo) {
          const allNo = restaurantConfig.posAllCategoriesNo
          categoryNoToCntMap[allNo] = (categoryNoToCntMap[allNo] || 0) + item.cnt
        }
        item.categories.forEach(category => {
          categoryNoToCntMap[category] = (categoryNoToCntMap[category] || 0) + item.cnt
        })
        if (item.swapBuyProducts?.length) {
          calcViewCartItems(item.swapBuyProducts, true)
        }
        if (item.fullItemNFreeProducts?.length) {
          calcViewCartItems(item.fullItemNFreeProducts, true)
        }
        if (item.disabled) {
          return
        }
        // boxPrice += item.totalBoxPrice
        // 餐品总价: 餐品原价金额累计
        presentItemPrice += item.totalPrice
        // 餐品实付总金额: 餐品原价累计 + 单品打包费
        // TODO:2023/05/09 整单打包费 => 餐品的实付不包含打包费
        totalPrice += item.totalPrice
        // 餐品原价总计: 餐品原价金额累计
        itemPrice += item.totalPrice
        // 餐品打包费累计
        // totalCartBoxPrice += item.totalBoxPrice
        // 餐品实价 + 餐品打包费 = 购物车价格
        // totalCartPrice += item.totalPrice + item.totalBoxPrice
      })
    }
    // 计算购物车订单项
    const calcViewOrderItems = (viewOrderItems: IViewOrderDetail[]) => {
      viewOrderItems.forEach(item => {
        totalCnt += item.cnt
        if (!(item.refundCnt && item.refundCnt === item.originalCnt)) {
          // boxPrice += item.totalBoxPrice
          totalPrice += item.totalPrice
          itemPrice += item.totalPrice

          // totalOrderBoxPrice += item.totalBoxPrice
          // totalOrderPrice += item.totalPrice + item.totalBoxPrice
        }
        if (item.swapBuyProducts) {
          calcViewOrderItems(item.swapBuyProducts)
        }
        if (item.fullItemNFreeProducts) {
          calcViewOrderItems(item.fullItemNFreeProducts)
        }
      })
    }
    // 计算购物车订单项整单打包费
    const calcOrdersBoxFee = () => {
      orderMobx.viewOrderBoxPrice.forEach((item) => {
        orderBoxPrice += item.originalFee
      })
    }
    calcOrdersBoxFee()
    // 单品中的promoCode优惠金额
    let discountPromoCodeItemPrice = 0
    let discountBoxPrice = 0
    forEach(discountMobx.discountResult.itemMap, (itemDiscount, key) => {
      itemDiscount.items && itemDiscount.items.forEach(item => {
        if (item.offType === 'promoCode') {
          discountPromoCodeItemPrice += item.off
        }
        if (['memberCard', 'memberPrice'].includes(item.offType)) {
          discountMemberCardPrice += item.off
        }
        if (['activity', 'ladderDiscount'].includes(item.offType)) {
          activityPrice += item.off
        }
      })
      if (key.includes('_box') || key.includes('box_')) {
        discountBoxPrice += itemDiscount?.apportion?.off || 0
      }
    })
    const discountPromoCodePrice = toDecimal(discountPromoCodeItemPrice + discountPromoCodeWholePrice)
    const discountWholePrice = toDecimal(discountCouponPrice + discountActivityPrice + discountFloorPrice + discountIntegralMoneyPrice + discountPromoCodeWholePrice + discountPlanPrice)
    const discountItemCouponPrice = sum(Object.values(discountMobx.discountResult.itemMap).map(item => sumBy((item.items || []).filter(off => off.offType === 'coupon'), 'off')))
    // const discountExpressPrice = sumBy((discountMobx.discountResult.itemMap[`${this.info?.express?.pk}`]?.items || []), 'off')
    const discountExpressPrice = sumBy(map((this.info.expressList || [this.info.express]), (express) => (express?.pk && discountMobx.discountResult.itemMap[express?.pk]) || { itemAllOff: 0 }), 'itemAllOff')
    /** 配送费活动优惠,不包含优惠券 */
    const discountExpressActivityPrice = sumBy(map((this.info.expressList || [this.info.express]), (express) => (express?.pk && discountMobx.discountResult.itemMap[express?.pk] && some(discountMobx.discountResult.itemMap[express?.pk]?.items || [], item => item?.offType === 'activity')) ? discountMobx.discountResult.itemMap[express?.pk] : { itemAllOff: 0 }), 'itemAllOff')
    // 餐品级优惠
    let discountItemPrice = 0
    let discountCartItemPrice = 0
    let discountOrderItemPrice = 0
    discountCartItemPrice = this.viewCartItems.filter(item => !item.disabled).reduce((prv: number, cartItem) => {
      let price = cartItem.offPrice
      // 换购品
      if (cartItem.swapBuyProducts?.length) {
        price += cartItem.swapBuyProducts.filter(item => !item.disabled).reduce((p: number, s) => {
          return p + s.offPrice
        }, 0)
      }
      // 满送品
      if (cartItem.fullItemNFreeProducts?.length) {
        price += cartItem.fullItemNFreeProducts.filter(item => !item.disabled).reduce((p: number, s) => {
          return p + s.offPrice
        }, 0)
      }
      return prv + price
    }, 0)
    if (this.info.payMode || this.posOrderPay) {
      discountOrderItemPrice = this.viewOrderItems.reduce((prv: number, orderItem) => {
        let price = orderItem.offPrice
        // 换购品
        if (orderItem.swapBuyProducts?.length) {
          price += orderItem.swapBuyProducts.reduce((p: number, s) => {
            return p + s.offPrice
          }, 0)
        }
        // 满送品
        if (orderItem.fullItemNFreeProducts?.length) {
          price += orderItem.fullItemNFreeProducts.reduce((p: number, s) => {
            return p + s.offPrice
          }, 0)
        }
        return prv + price
      }, 0)
    }
    // 购物车商品总优惠+已下单商品总优惠
    discountItemPrice = toDecimal(discountCartItemPrice + discountOrderItemPrice)
    // 总优惠
    let totalDiscountPrice = toDecimal(discountWholePrice + discountItemPrice + discountExpressPrice)
    // 当前如果已下单
    const serviceCharge = feeMobx.calculatedServiceChargeTotal
    const serviceChargeDetail = cloneDeep(feeMobx.calculatedServiceCharge)
    // TODO:2023/05/09: 抽离打包费计算模块，打包费走boxFeeMobx
    const getUseBoxPrice = () => {
      if (this.viewCartItems.length === 0 && orderMobx.viewOrder.ordersId) {
        // 订单购物车没有加菜项使用订单
        const isOrdersBoxFee = !!orderMobx.viewOrderBoxPrice.find((item) => item.parentId + '' === '0')
        const isEmpty = this.viewOrderItems.filter((item) => !item.isAllRefund)
        if (isOrdersBoxFee && isEmpty.length !== 0) {
          // 订单购物车整单打包费还原到购物车
          boxPrice = orderBoxPrice
          return
        } else if (isOrdersBoxFee && isEmpty.length === 0) {
          // 订单购物车为空 整单打包费不加入计算
          boxPrice = 0
          return
        } else {
          if (!isOrdersBoxFee && isEmpty.length === 0) {
            // 单品打包费，购物车为空，不计算打包费
            boxPrice = 0
            return
          }
          boxPrice = boxFeeMobx.calcBoxFee({ cartItems: this.viewCartItems, ordersItems: this.viewOrderItems, boxFeeType: 'productBoxFee', eatType: cartMobx.info.eatType })
        }
        return
      } if (this.viewCartItems.length === 0) {
        boxPrice = 0
        return
      } else {
        boxPrice = boxFeeMobx.calcBoxFee({ cartItems: this.viewCartItems, ordersItems: this.viewOrderItems, eatType: cartMobx.info.eatType })
        return
      }
    }
    calcViewCartItems(this.viewCartItems)
    calcViewOrderItems(this.viewOrderItems)
    // 计算当前使用打包费
    getUseBoxPrice()
    totalPrice += boxPrice
    // 未下单购物车打包费总金额
    totalCartBoxPrice += boxPrice
    // 未下单购物车订单应收
    totalCartPrice = totalPrice
    totalOrderBoxPrice += boxPrice
    totalOrderPrice += boxPrice
    /** 计算打包费 */
    let tableAlias: any = ''
    if (this.info.tableCode) {
      tableAlias = deskMobx.tableCodeToTableAliasMap[this.info.tableCode] || this.info.tableAlias
    }
    totalPrice += (tax || 0)
    totalPrice += serviceCharge
    if (cartMobx.info.eatType === 'delivery') {
      totalPrice += expressPrice
    }
    // 当前是否可直接发起支付，先付费 或 后付费已下过单切当前购物车无餐品
    let isCanPay = !this.info.payMode || (this.ordersId && !presentTotalCnt) || this.info._payMode === 2
    if (presentTotalCnt && !menuMobx.isAvailable) {
      isCanPay = false
    }
    // 手机端后付费不支持支付
    // isCanPay = isCanPay && !(restaurantConfig.app === 'mobile' && this.info.payMode)
    isCanPay = isCanPay && !(restaurantConfig.app === 'mobile' && (this.info.payMode ? !(storeMobx.storeSceneConfig?.openAfterPayCustomerPay || !storeMobx.storeSceneConfig?.payMode) : this.info.payMode))
    // 可下单
    let isCanSave = presentTotalCnt && menuMobx.isAvailable
    const nono = this.ordersId ? orderMobx.viewOrder.nono : undefined
    const isTogo = this.info.eatType !== 'dinein' ? 1 : 0
    totalPrice = toDecimal(totalPrice - totalDiscountPrice)
    const paidPrice = toDecimal(totalPrice - tax)
    const addTime = this.ordersId ? orderMobx.viewOrder.addTime : ddayjs().format()
    const taxItems = feeMobx.taxCategoryResult.map(item => {
      const hasServiceCharge = item.items.some(item => !item.pk)
      const hasExpressCharge = item.items.some(item => item.productNo === 'express')
      const hasBoxCharge = item.items.some(item => item.productNo === 'box')
      const items = item.items.filter(item => item.productNo !== 'express' && item.productNo !== 'box')
      const quantityRateItems = item.items.filter(item => item?.quantityRate !== undefined)
      const extraQuantity = quantityRateItems?.length ? {
        count: sumBy(quantityRateItems, i => i.cnt || 0),
        rate: quantityRateItems?.[0]?.quantityRate || 0
      } : undefined
      return {
        name: item.name,
        taxCategoryId: item.taxCategoryId,
        amount: item.amount,
        rate: toDecimal(item.rate * 100),
        count: sumBy(items, i => i.cnt || 0) + (hasServiceCharge ? 1 : 0) + (hasExpressCharge ? 1 : 0) + (hasBoxCharge ? 1 : 0),
        hasServiceCharge,
        hasExpressCharge,
        hasBoxCharge,
        isTaxFree: !!items?.length && items.every(value => !!value.isTaxFree),
        extraQuantity
      }
    })
    return {
      allProductNoToCntMap,
      productNoToCntMap,
      categoryNoToCntMap,
      allScaleNoToCntMap,
      scaleNoToCntMap,
      swapBuyProductScaleNoToCntMap,
      fullItemNFreeProductScaleNoToCntMap,
      orderSwapBuyProductNoToCntMap,
      orderSwapBuyProductScaleNoToCntMap,
      itemActualPrice: toDecimal(itemPrice - discountItemPrice - showTax),
      itemTotalPrice: toDecimal(itemPrice - totalDiscountPrice - showTax),
      discountItemPrice,
      discountWholePrice,
      discountPlanPrice,
      discountCouponPrice,
      discountItemCouponPrice,
      discountActivityPrice,
      discountFloorPrice,
      discountIntegralMoneyPrice,
      discountPromoCodeWholePrice,
      discountPromoCodeItemPrice,
      discountPromoCodePrice,
      discountExpressPrice,
      discountExpressActivityPrice,
      discountBoxPrice,
      totalDiscountPrice: toDecimal(totalDiscountPrice),
      serviceCharge,
      serviceChargeDetail,
      expressPrice,
      boxPrice,
      tax,
      freeTax,
      showTax,
      totalPrice: toDecimal(totalPrice),
      paidPrice,
      tip: 0,
      totalPriceExcludeTip: toDecimal(totalPrice - 0),
      itemPrice,
      presentItemPrice,
      totalOriginalPrice: toDecimal(paidPrice + totalDiscountPrice),

      presentTotalCnt,
      tableAlias,
      totalCnt,
      isCanPay: !!isCanPay,
      isCanSave: !!isCanSave,
      modified: Date.now(),
      nono,
      addTime,
      offItems,
      floorOffItem,
      integralMoneyOffItem,
      // promoCodeOffItem,
      orderPlanOffItem,
      isTogo,
      taxItems,
      totalCartPrice: toDecimal(totalCartPrice - discountCartItemPrice),
      totalCartBoxPrice,
      totalOrderPrice: toDecimal(totalOrderPrice - discountOrderItemPrice),
      totalOrderBoxPrice,
      discountMemberCardPrice,
      activityPrice
    }
  }

  /** 返回当前购物车中所有餐品是否有设置过餐品备注 */
  get cartProductHasReamrkStatus (): boolean {
    return this.cartItems.some(cartitem => {
      return cartitem.remark.length
    })
  }

  /** 是否全选打包 */
  get isPackCheckAll (): boolean {
    const cartPackFkeys = this.cartPackFkeys
    const cartAll = this.viewCartItems.filter(cartItem => cartItem.isCanTogo).every((cartItem: any) => {
      if (cartItem.isOrderSwapBuy) {
        return cartPackFkeys[`${cartItem.fkey}_${cartItem.pk}`] === cartItem.cnt
      } else {
        return cartPackFkeys[cartItem.fkey] === cartItem.cnt
      }
    })
    const swapBuyCartAll = flatten(pick(this.viewCartItems, 'swapBuyProducts')).filter((swapItem: any) => swapItem.isCanTogo).every(swapItem => cartPackFkeys[`${swapItem?.fkey}_swapBuy_${swapItem?.pk}`] === swapItem?.cnt)
    const fullNFreeCartAll = flatten(pick(this.viewCartItems, 'fullItemNFreeProducts')).filter(fullNFreeItem => fullNFreeItem?.isCanTogo).every(fullNFreeItem => cartPackFkeys[`${fullNFreeItem?.fkey}_fullNFree_${fullNFreeItem?.pk}`] === fullNFreeItem?.cnt)
    return cartAll && swapBuyCartAll && fullNFreeCartAll
  }

  /** 打包数量 */
  get packedCnt () {
    const viewCarts = this.viewCartItems.filter(item => item.cnt && !item.disabled && item.isTogo)
    this.viewCartItems.filter(item => item.cnt && !item.disabled && (item.swapBuyProducts?.length || item.fullItemNFreeProducts?.length)).forEach(item => {
      item.swapBuyProducts && viewCarts.push(...item.swapBuyProducts.filter(swapItem => swapItem.cnt && !swapItem.disabled && swapItem.isTogo))
      item.fullItemNFreeProducts && viewCarts.push(...item.fullItemNFreeProducts.filter(fullNFreeItem => fullNFreeItem.cnt && !fullNFreeItem.disabled && fullNFreeItem.isTogo))
    })
    return viewCarts.reduce((pre, cur) => pre + cur.cnt, 0)
  }

  /** 渠道 */
  get channel () {
    let channel = productMobx.channel
    if (restaurantConfig.buyTogetherId) {
      channel = 'buyTogether'
    } else if (restaurantConfig.codeType === 'brand' && ['pickup', 'delivery'].includes(this.info.eatType)) {
      channel = 'selfDelivery'
    }
    // 手机下单，pos加餐修改渠道
    if (restaurantConfig.app === 'pos' && channel === 'mobile') {
      channel = 'pos'
    }
    return channel
  }

  /** 是否有非特殊预约餐品 */
  get checkHasOrderTimeProduct () {
    return !!some(this.cartItems, (item) => !item.startTime)
  }

  /** 获取购物车内最早的特殊预约餐品时间 */
  get getFirstStartTimeFromProductRule (): string {
    // 有非特殊预约餐品
    if (this.checkHasOrderTimeProduct) {
      return this.info.startTime || ''
    }
    const startTime = minBy(this.cartItems, 'startTime')?.startTime || ''
    return startTime
  }

  /** 是否有需要等待确定订单 */
  get isWait (): boolean {
    return this.info.payMode === 1 && orderMobx.viewOrder.isWait
  }

  /** 获取当前购物车pks */
  get cartPks () {
    return unionBy([...map(this.viewOrderItems, 'pk'), ...map(this.cartItems, 'pk')])
  }

  /** 设置购物车餐品 主要来自localStorage */
  setCartItems (newCartItem: ICartItem[], cache?: boolean) {
    this.cartItems = cloneDeep(newCartItem)
    if (cache || restaurantConfig.buyTogetherId) {
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED, {
        type: 'change',
        cartItems: this.cartItems,
        cache,
      })
    }
  }

  /** 设置暂存购物车 */
  setCacheCartItems (cartItems?: ICartItem[]) {
    this.cacheCartItems = cloneDeep(cartItems || [])
  }

  /** 设置购物车信息  主要来自localStorage */
  setCartInfo (newInfo: ICartInfo) {
    this.info = cloneDeep(newInfo)
  }

  syncAllToCart (syncCartItems: ISyncCartItem[]) {
    if (syncCartItems && syncCartItems.length) {
      this.cartItems = syncCartItems.map(syncCartItem => {
        return {
          ...syncCartItem,
          name: '',
          scaleName: '',
          isTogo: syncCartItem.isTogo,
          startTimeOffset: 0
        }
      }).filter(item => !!item && item.cnt > 0)
      this.initCartPackFkeys()
    }
  }

  /** 设置用户与门店的距离 */
  setDistance (distance: number = -1) {
    if (distance >= 0) {
      this.info.distance = distance
    } else {
      delete this.info.distance
    }
  }

  syncToCart (syncCartItem: ISyncCartItem) {
    const isCombo = ['FixedCombo', 'OptionalCombo'].includes(syncCartItem.type)
    const cartItem = cartMobx.pkToViewCartItemMap[syncCartItem.pk]
    if (cartItem && (!isCombo || (isCombo && (syncCartItem?.pk === cartItem?.pk || syncCartItem.cnt === 0)))) {
      const theCartItem = this.cartItems.find(cartItem => cartItem.pk === syncCartItem.pk)
      if (theCartItem) {
        if (syncCartItem.cnt === 0) {
          this.remove(theCartItem.pk, true)
        } else {
          const syncCnt = syncCartItem.cnt - theCartItem.cnt
          const isAdd = syncCartItem.cnt > theCartItem.cnt
          theCartItem.cnt = syncCartItem.cnt
          theCartItem.remark = syncCartItem.remark
          theCartItem.swapBuyProducts = syncCartItem.swapBuyProducts
          theCartItem.fullItemNFreeProducts = syncCartItem.fullItemNFreeProducts
          theCartItem.fkey = syncCartItem.fkey
          theCartItem.productGroups = syncCartItem.productGroups
          theCartItem.modifierGroups = syncCartItem.modifierGroups
          theCartItem.scaleNo = syncCartItem.scaleNo
          restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
            type: isAdd ? 'add' : 'change',
            cartItem: theCartItem,
            fromSync: true, // 记录一个标记是否来自于同步
            syncCnt
          })
          // 自动计算满送
          // this.autoFullNFree()
        }
      }
    } else {
      const viewProduct = productMobx.noToViewProductMap[syncCartItem.productNo]
      if (viewProduct) {
        const scale = viewProduct.scales.find(scale => scale.no === syncCartItem.scaleNo)
        if (scale) {
          const newCartItem = {
            ...syncCartItem,
            name: viewProduct.name,
            scaleName: scale.name,
            isTogo: syncCartItem.isTogo,
            startTimeOffset: 0
          }
          this.insert(newCartItem)
          restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
            type: 'add',
            cartItem: newCartItem,
            fromSync: true, // 记录一个标记是否来自于同步
            syncCnt: syncCartItem.cnt
          })
        }
      }
    }
  }

  setContactUpdate (status: boolean) {
    this.isUpdateContact = status
  }

  syncClear () {
    if (!this.cartItems.length) {
      return
    }
    this.safeClear()
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
      type: 'clear',
      fromSync: true
    })
  }

  setInfoPerson (person: number) {
    this.info.person = person
  }

  /** 添加餐品到购物车, 支持doProduct/doCombo对象 */
  addToCart (doProduct: IDoProduct | IDoCombo): TSaveCartError | string | undefined {
    const pkToViewCartItemMap = this.pkToViewCartItemMap
    const type = doProduct.type
    const productNo = doProduct.no
    const scaleNo = doProduct.scaleNo
    const remark = doProduct.remark || ''
    const seat = doProduct.seat || ''
    const salesCnt = doProduct.salesCnt
    const startTimeOffset = doProduct.startTimeOffset || 0
    const doScale = doProduct.scales.find((scale) => scale.no === scaleNo)
    const price = doScale?.isOpenPrice ? (doScale && doScale.price) || 0 : undefined
    const swapBuyProducts = doProduct.swapBuyProducts?.length ? doProduct.swapBuyProducts : []
    const timestamp = doProduct.timestamp
    const startTime = doProduct.startTime
    const pickTimeRange = doProduct.pickTimeRange
    let openPriceX = doProduct.itemPlan?.type === 'changeFee' ? doProduct.itemPlan.value : -1
    /**
     * true: 是整单换购的餐品
     * false: 非整单换购餐品
     */
    const isOrderSwapBuy = doProduct.isOrderSwapBuy || false
    if (!scaleNo) {
      console.error('scale id is null')
      return TSaveCartError.DATA_ERROR
    }
    // 套餐
    const productGroups = (doProduct as IDoCombo).productGroups || undefined
    // 有pk则认为是一个购物车的修改
    const pk = doProduct.pk
    const isTogo = restaurantConfig.app !== 'pos' ? (this.info.eatType !== 'dinein' ? 1 : 0) : doProduct.isTogo
    const isCanTogo = doProduct.isCanTogo
    const isSingleSale = doProduct.isSingleSale
    const modifierGroups = convertDoModifierGroupsToModifierGroups(doProduct.modifierGroups)
    const addUserId = doProduct.addUserId || restaurantConfig?.member?.key || ''
    const addUserName = doProduct.addUserName || restaurantConfig?.member?.nickName || ''
    const addUserAvatar = doProduct.addUserAvatar || restaurantConfig?.member?.avatar || ''
    const fkey = createFkey({ productNo, scaleNo, modifierGroups, addUserId, isTogo, startTime, isSeat: doProduct.seat || '-1', isOrderSwapBuy, productGroups, openPriceX: openPriceX, price })
    const isTaxFree = (doProduct as IDoProduct).isTaxFree || false
    if (pk) {
      if (!productGroups?.length && restaurantConfig.autoMergeCartItem) {
        if (doProduct.itemPlan?.tagId) {
          const itemPlanTagId = doProduct.itemPlan?.tagId
          this.viewCartItems
            .filter(item => {
              const isSame = item.offItemPlanTagId === itemPlanTagId
              return item.fkey === fkey && isSame
            })
            .filter(item => item.pk !== pk)
            .forEach(item => {
              const cartItem = this.cartItems.find(i => i.pk === item.pk)
              if (cartItem) {
                this.remove(cartItem)
                doProduct.cnt += cartItem.cnt
                swapBuyProducts.push(...(item.swapBuyProducts || []))
              }
            })
        } else if (doProduct.itemPlan?.type === 'discountFee' || doProduct.itemPlan?.type === 'discountRate') {
          const itemPlanType = doProduct.itemPlan?.type
          const itemPlanValue = doProduct.itemPlan?.value
          this.viewCartItems
            .filter(item => {
              const isSamePrice = itemPlanType === 'discountFee' ? itemPlanValue === item.offItems[0]?.off : itemPlanType === 'discountRate' ? item.offItems[0]?.off === toDecimal((itemPlanValue || 0) * (price || 0), 7) : false
              const isSame = isSamePrice && item.offItems[0]?.offType === 'plan' && item.offItems[0]?.offTip === doProduct.itemPlan?.reason
              return item.fkey === fkey && isSame
            })
            .filter(item => item.pk !== pk)
            .forEach(item => {
              const cartItem = this.cartItems.find(i => i.pk === item.pk)
              if (cartItem) {
                this.remove(cartItem)
                doProduct.cnt += cartItem.cnt
                swapBuyProducts.push(...(item.swapBuyProducts || []))
              }
            })
        } else {
          this.viewCartItems
            .filter(item => item.fkey === fkey && !item.offItemPlanTagId && !get(discountMobx.discountAction.itemPlan, [item.pk]))
            .filter(item => item.pk !== pk)
            .forEach(item => {
              const cartItem = this.cartItems.find(i => i.pk === item.pk)
              if (cartItem) {
                this.remove(cartItem)
                doProduct.cnt += cartItem.cnt
                swapBuyProducts.push(...(item.swapBuyProducts || []))
              }
            })
        }
      }

      // pos自动合并套餐内商品
      if (productGroups) {
        productGroups?.forEach((item, index: number) => {
          productGroups[index] = {
            ...item,
            productGroupDetails: mergeProductGroupModifier(item.productGroupDetails)
          }
        })
      }
      const cartItemIndex = this.cartItems.findIndex(item => item.pk === pk)
      if (typeof (this.cartItems[cartItemIndex]?.openPriceX) !== 'undefined' && this.cartItems[cartItemIndex]?.openPriceX !== -1) {
        if (openPriceX === -1) {
          openPriceX = this.cartItems[cartItemIndex]?.openPriceX || 0
        }
      }
      const newCartItem = createCartItem({ type, productNo, price, fkey, scaleNo, modifierGroups, productGroups, isTogo, isCanTogo, isSingleSale, remark, seat, startTimeOffset, pk, addUserId, addUserName, addUserAvatar, isTaxFree, swapBuyProducts, timestamp, startTime, pickTimeRange, isOrderSwapBuy, openPriceX, salesCnt })
      if (newCartItem) {
        newCartItem.cnt = doProduct.cnt
        newCartItem.swapBuyProducts = reduceSwapBuy({
          swapBuyProducts: newCartItem.swapBuyProducts,
          length: newCartItem.cnt
        })
        this.cartItems.splice(cartItemIndex, 1, newCartItem)
        // repeatItemIndex !== -1 && this.cartItems.splice(repeatItemIndex, 1)
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'change',
          cartItem: newCartItem,
          itemPlan: doProduct.itemPlan
        })
        // 自动计算满送
        // this.autoFullNFree()
      }
    } else {
      // 手机端自动合并 kiosk 自动合并
      const isAutoMerge = !productGroups?.length && !doProduct.isOrderSwapBuy
      if (isAutoMerge && (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk')) {
        const cartItem = this.cartItems.find(item => item.fkey === fkey)
        if (cartItem) {
          cartItem.cnt = cartItem.cnt + doProduct.cnt
          cartItem.swapBuyProducts = reduceSwapBuy({
            swapBuyProducts: [...(cartItem.swapBuyProducts || []), ...(swapBuyProducts || [])],
            length: cartItem.cnt
          })
          restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
            type: 'change',
            cartItem: cartItem,
            itemPlan: doProduct.itemPlan
          })
          // 自动计算满送
          // this.autoFullNFree()
          return cartItem.pk
        }
      }
      // 店长端自动合并
      if (isAutoMerge && restaurantConfig.app === 'pos' && restaurantConfig.autoMergeCartItem) {
        const itemPlanTagId = doProduct.itemPlan?.tagId
        const itemPlanType = doProduct.itemPlan?.type
        const itemPlanValue = doProduct.itemPlan?.value
        const viewCartItem: any = this.viewCartItems
          .find(item => {
            const isSameTagId = itemPlanTagId && item.offItemPlanTagId && itemPlanTagId === item.offItemPlanTagId
            const isSamePrice = itemPlanType === 'discountFee' ? itemPlanValue === item.offItems[0]?.off : itemPlanType === 'discountRate' ? item.offItems[0]?.off === toDecimal((itemPlanValue || 0) * (price || 0), 7) : false
            const isSameDiscount = isSamePrice && item.offItems[0]?.offType === 'plan' && item.offItems[0]?.offTip === doProduct.itemPlan?.reason
            return item.fkey === fkey && (isSameTagId || isSameDiscount || (!item.offItemPlanTagId && !item.offItems?.length))
          })
        const cartItem = this.cartItems
          .filter(item => !pkToViewCartItemMap[viewCartItem?.pk] || pkToViewCartItemMap[viewCartItem?.pk]?.pk === item?.pk)
          .find(item => item.fkey === fkey)
        if (cartItem && viewCartItem) {
          cartItem.cnt = cartItem.cnt + doProduct.cnt
          cartItem.swapBuyProducts = reduceSwapBuy({
            swapBuyProducts: [...(cartItem.swapBuyProducts || []), ...(swapBuyProducts || [])],
            length: cartItem.cnt
          })
          restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
            type: 'change',
            cartItem: cartItem,
            itemPlan: doProduct.itemPlan
          })
          return cartItem.pk
        }
      }

      // pos自动合并套餐内商品
      if (productGroups) {
        productGroups?.forEach((item, index: number) => {
          productGroups[index] = {
            ...item,
            productGroupDetails: mergeProductGroupModifier(item.productGroupDetails)
          }
        })
      }
      const newCartItem = createCartItem({ type, productNo, price, fkey, scaleNo, modifierGroups, productGroups, isTogo, isCanTogo, isSingleSale, cnt: doProduct.cnt, remark, seat, startTimeOffset, addUserId, addUserName, addUserAvatar, isTaxFree, swapBuyProducts, timestamp, startTime, pickTimeRange, isOrderSwapBuy, openPriceX, salesCnt })
      if (newCartItem) {
        this.insert(newCartItem)
        newCartItem.swapBuyProducts = reduceSwapBuy({
          swapBuyProducts: newCartItem.swapBuyProducts,
          length: newCartItem.cnt
        })
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'add',
          cartItem: newCartItem,
          itemPlan: doProduct.itemPlan
        })
        // 自动计算满送
        // this.autoFullNFree()
      }
      return newCartItem?.pk
    }
  }

  /** 插入餐品到购物车 处理餐品插入逻辑(cartItems.push) */
  insert (cartItem: ICartItem) {
    if (cartItem.isOrderSwapBuy) {
      this.cartItems.push(cartItem)
    } else if (restaurantConfig.app === 'pos' && restaurantConfig.autoMergeCartItem) {
      const planItemIdx = this.viewCartItems.findIndex(item => !!item.offItemPlanTagId && item.fkey === cartItem.fkey)
      if (planItemIdx === -1) {
        this.cartItems.push(cartItem)
      } else {
        this.cartItems.splice(planItemIdx, 0, cartItem)
      }
    } else if (restaurantConfig.app === 'mobile' || restaurantConfig.app === 'kiosk') {
      const noIdx = findLastIndex(this.viewCartItems, item => cartItem.productNo === item.productNo)
      const noScaleNoIdx = findLastIndex(this.viewCartItems, item => cartItem.productNo === item.productNo && cartItem.scaleNo === item.scaleNo)
      if (~noIdx && ~noIdx) {
        this.cartItems.splice(noScaleNoIdx > -1 ? noScaleNoIdx : noIdx, 0, cartItem)
      } else {
        this.cartItems.push(cartItem)
      }
    } else {
      this.cartItems.push(cartItem)
      return
    }
  }

  /** 拆分购物车项 */
  setSplitCartItem (pk?: string, changeCnt?: number, newCnt?: number) {
    const itemIdx = this.cartItems?.findIndex(i => i.pk === pk)
    if (pk && changeCnt && (itemIdx !== -1)) {
      const cartItem = Object.assign(cloneDeep(this.cartItems[itemIdx] as ICartItem), { pk: doPk() })
      cartItem.cnt = (newCnt || cartItem.cnt) - (changeCnt || 0)
      cartItem.fkey = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: cartItem.isTogo, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
      this.cartItems.splice(itemIdx, 0, cartItem)
      discountMobx.discountAction.itemPlan[pk] && discountMobx.setItemPlan(cartItem.pk, discountMobx.discountAction.itemPlan[pk])
      newCnt && ((this.cartItems.find(i => i.pk === pk) as ICartItem).cnt = newCnt)
    }
  }

  /** 递增餐品数量，支持cartItem 支持pk 支持多人模式 */
  add (cart: ICartItem | string | string[]) {
    // 增加的时候混杂了多人时，增加的 则是自己的餐品
    let cartItem: ICartItem | undefined
    if (Array.isArray(cart)) {
      cartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk) && cartItem.addUserId === restaurantConfig?.member?.key)
      // console.log(cartItem, 'cartItem')
      if (!cartItem) {
        const oneCartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk))
        if (oneCartItem) {
          cartItem = cloneDeep(oneCartItem)
          cartItem.addUserId = restaurantConfig?.member?.key || ''
          cartItem.addUserName = restaurantConfig?.member?.nickName || ''
          cartItem.addUserAvatar = restaurantConfig?.member?.avatar || ''
          cartItem.cnt = 1
          cartItem.pk = doPk()
          cartItem.fkey = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: cartItem.isTogo, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
          this.insert(cartItem)
        }
      } else {
        cartItem.cnt++
      }
    } else {
      cartItem = this.cartItems.find(item => item.pk === (typeof cart === 'string' ? cart : cart.pk))
      cartItem && cartItem.cnt++
    }
    if (cartItem) {
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: cartItem
      })
      // 自动计算满送
      // this.autoFullNFree()
    }
  }

  /** 递减餐品数量，如果删除到0则删除该cartItem，支持cartItem 支持pk 支持菜单中的餐品 支持多人模式 */
  reduce (cart: ICartItem | string | IViewProduct | string[], isOrderSwapBuy?: boolean) {
    let cartItem: ICartItem | undefined
    if (Array.isArray(cart)) {
      cartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk) && cartItem.addUserId === restaurantConfig.member?.key)
      if (!cartItem) {
        // TODO 当前无需指定先修改某一个用户的餐品
        cartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk))
      }
    } else if (typeof cart === 'string' || (cart as ICartItem).pk) {
      cartItem = this.cartItems.find(item => typeof cart === 'string' ? item.pk === cart : item.pk === (cart as ICartItem).pk)
    } else {
      cartItem = findLast(this.cartItems, item => (item.isOrderSwapBuy || false) === (isOrderSwapBuy || false) && item.productNo === (cart as IViewProduct).no)
    }
    if (cartItem) {
      // 减餐品低于起售数，就直接清空
      if (restaurantConfig.app === 'mobile' && cartItem.salesCnt && cartItem.cnt <= cartItem.salesCnt) {
        this.remove(cartItem)
        return
      }
      if (cartItem.cnt <= 0) {
        this.remove(cartItem)
        return
      }
      cartItem.cnt--
      cartItem.swapBuyProducts = reduceSwapBuy({
        swapBuyProducts: cartItem.swapBuyProducts,
        length: cartItem.cnt
      })
      if (!cartItem.cnt) {
        const index = this.cartItems.findIndex(item => item.pk === (cartItem as ICartItem).pk)
        if (~index) {
          this.cartItems.splice(index, 1)
        }
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'remove',
          cartItem
        })
        // 自动计算满送
        // this.autoFullNFree()
      } else {
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'change',
          cartItem
        })
        // 自动计算满送
        // this.autoFullNFree()
      }
    }
  }

  /** 直接更换购物车餐品数量 */
  changeCnt (cart: ICartItem | string | IViewProduct | string[], cnt: number, isOrderSwapBuy?: boolean) {
    let cartItem: ICartItem | undefined
    if (Array.isArray(cart)) {
      cartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk) && cartItem.addUserId === restaurantConfig.member?.key)
      if (!cartItem) {
        // TODO 当前无需指定先修改某一个用户的餐品
        cartItem = this.cartItems.find(cartItem => cart.includes(cartItem.pk))
      }
    } else if (typeof cart === 'string' || (cart as ICartItem).pk) {
      cartItem = this.cartItems.find(item => typeof cart === 'string' ? item.pk === cart : item.pk === (cart as ICartItem).pk)
    } else {
      cartItem = findLast(this.cartItems, item => (item.isOrderSwapBuy || false) === (isOrderSwapBuy || false) && item.productNo === (cart as IViewProduct).no)
    }
    if (cartItem) {
      // 减餐品低于起售数，就直接清空
      if (restaurantConfig.app === 'mobile' && cartItem.salesCnt && cnt < cartItem.salesCnt) {
        this.remove(cartItem)
        return
      }
      if (cnt <= 0) {
        this.remove(cartItem)
        return
      }
      cartItem.cnt = cnt
      cartItem.swapBuyProducts = reduceSwapBuy({
        swapBuyProducts: cartItem.swapBuyProducts,
        length: cartItem.cnt
      })
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem
      })
    }
  }

  /** 删除餐品，支持cartItem也支持fkey 支持多人模式 */
  remove (cart: ICartItem | string | string[], fromSync = false) {
    if (Array.isArray(cart)) {
      cart.forEach(pk => this.remove(pk))
    } else {
      const index = this.cartItems.findIndex(item => item.pk === (typeof cart === 'string' ? cart : cart.pk))
      if (~index) {
        // 保证事件到达时数量是正确的，即为0
        const cpCartItem = cloneDeep(this.cartItems[index])
        cpCartItem.cnt = 0
        this.cartItems.splice(index, 1)
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'remove',
          cartItem: cpCartItem,
          fromSync
        })
        // 自动计算满送
        // this.autoFullNFree()
      }
    }
  }

  replace (cart: ICartItem | string | string[]) {
    let cartItems: ICartItem[] = this.cartItems.filter(cartItem => cartItem.addUserId !== restaurantConfig?.member?.key)
    this.cartItems = cartItems
    if (Array.isArray(cart)) {
      cartItems.forEach((oneCartItem: ICartItem) => {
        if (cart.includes(oneCartItem.pk)) {
          this.insert(replaceCartItem(oneCartItem))
        }
      })

      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED, {
        type: 'change',
        cartItems: this.cartItems
      })
    }
  }

  /** 清空购物车 */
  clear () {
    if (!this.cartItems.length) {
      return
    }
    this.cartItems = []
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
      type: 'clear'
    })
  }

  /** 添加单品换购餐品 */
  addSwapBuyToCart (doProduct: IDoProduct, parentCartItemPk?: string): TSaveCartError | undefined {
    if (!parentCartItemPk) {
      this.addToCart(doProduct)
      return
    }
    const type = doProduct.type
    const productNo = doProduct.no
    const scaleNo = doProduct.scaleNo
    const remark = doProduct.remark || ''
    const startTimeOffset = doProduct.startTimeOffset || 0
    const doScale = doProduct.scales.find((scale) => scale.no === scaleNo)
    const timestamp = doProduct.timestamp
    const startTime = doProduct.startTime
    const pickTimeRange = doProduct.pickTimeRange
    if (!scaleNo) {
      console.error('scale id is null')
      return TSaveCartError.DATA_ERROR
    }
    const price = doScale?.isOpenPrice ? (doScale && doScale.price) || 0 : undefined
    const pk = doProduct.pk
    const isTogo = restaurantConfig.app !== 'pos' ? (this.info.eatType !== 'dinein' ? 1 : 0) : doProduct.isTogo
    const isCanTogo = doProduct.isCanTogo
    const isSingleSale = doProduct.isSingleSale
    const modifierGroups = convertDoModifierGroupsToModifierGroups(doProduct.modifierGroups)
    const addUserId = doProduct.addUserId || restaurantConfig?.member?.key || ''
    const addUserName = doProduct.addUserName || restaurantConfig?.member?.nickName || ''
    const addUserAvatar = doProduct.addUserAvatar || restaurantConfig?.member?.avatar || ''
    const fkey = createFkey({ productNo, scaleNo, modifierGroups, addUserId, isTogo, startTime, isSeat: doProduct.seat || '-1', isOrderSwapBuy: doProduct.isOrderSwapBuy, openPriceX: doProduct.openPriceX, price })
    const isTaxFree = (doProduct as IDoProduct).isTaxFree || false
    const parentCartItem = this.cartItems.find(item => item.pk === parentCartItemPk)
    if (parentCartItem) {
      parentCartItem.swapBuyProducts = parentCartItem.swapBuyProducts || []
      const cartItemIndex = parentCartItem.swapBuyProducts.findIndex(item => item.pk === pk)
      if (pk && cartItemIndex > -1) {
        const newCartItem = createCartItem({ type, productNo, price, fkey, scaleNo, modifierGroups, isTogo, isCanTogo, isSingleSale, remark, startTimeOffset, pk, addUserId, addUserName, addUserAvatar, isTaxFree, timestamp, startTime, pickTimeRange })
        if (newCartItem) {
          newCartItem.cnt = doProduct.cnt
          newCartItem.parentPk = parentCartItemPk
          parentCartItem.swapBuyProducts.splice(cartItemIndex, 1, newCartItem)
        }
      } else {
        const newCartItem = createCartItem({ type, productNo, price, fkey, scaleNo, modifierGroups, isTogo, isCanTogo, isSingleSale, cnt: doProduct.cnt, remark, startTimeOffset, addUserId, addUserName, addUserAvatar, isTaxFree, timestamp, startTime, pickTimeRange })
        if (newCartItem) {
          newCartItem.parentPk = parentCartItemPk
          parentCartItem.swapBuyProducts.push(newCartItem)
        }
      }
      const parentCartItemIndex = this.cartItems.findIndex(item => item.pk === parentCartItemPk)
      this.cartItems.splice(parentCartItemIndex, 1, parentCartItem)
      const itemPlan = (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[parentCartItemPk]) || null
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: parentCartItem,
        itemPlan
      })
      // 自动计算满送
      // this.autoFullNFree()
    }
  }

  /** 删除单品换购餐品 */
  removeSwapBuyToCart (cartItem: ICartItem | string, parentCartItemPk?: string) {
    if (!parentCartItemPk) {
      this.remove(cartItem)
      return
    }
    const parentCartItem = this.cartItems.find(item => item.pk === parentCartItemPk)
    if (parentCartItem && parentCartItem?.swapBuyProducts?.length) {
      const index = parentCartItem.swapBuyProducts.findIndex(item => item.pk === (typeof cartItem === 'string' ? cartItem : cartItem.pk))
      if (~index) {
        const cpCartItem = cloneDeep(parentCartItem.swapBuyProducts[index])
        cpCartItem.cnt = 0
        parentCartItem.swapBuyProducts.splice(index, 1)
      }
      const parentCartItemIndex = this.cartItems.findIndex(item => item.pk === parentCartItemPk)
      this.cartItems.splice(parentCartItemIndex, 1, parentCartItem)
      const itemPlan = (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[parentCartItemPk]) || null
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: parentCartItem,
        itemPlan
      })
      // 自动计算满送
      // this.autoFullNFree()
    }
  }

  /** 设置换购品预约时间 */
  setSwapBuyCartItemStartTime (cartItem: IViewCartItem, startTime?: string, pickTimeRange?: any) {
    const parentCartItem = this.cartItems.find(item => item.pk === cartItem.parentPk)
    if (cartItem.isOrderSwapBuy) {
      this.setCartItemStartTime(cartItem, startTime, pickTimeRange)
    } else if (parentCartItem && parentCartItem?.swapBuyProducts?.length) {
      const index = parentCartItem.swapBuyProducts.findIndex(item => item.pk === cartItem.pk)
      if (~index) {
        const cpCartItem = cloneDeep(parentCartItem.swapBuyProducts[index])
        cpCartItem.startTime = startTime
        cpCartItem.pickTimeRange = pickTimeRange
        parentCartItem.swapBuyProducts.splice(index, 1, cpCartItem)
      }
      const parentCartItemIndex = this.cartItems.findIndex(item => item.pk === cartItem.parentPk)
      this.cartItems.splice(parentCartItemIndex, 1, parentCartItem)
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: parentCartItem
      })
    }
  }

  /** 批量移除单品换购餐品 */
  reduceSwapBuy ({ swapBuyProducts, length }: { swapBuyProducts?: any[]; length?: number }) {
    return swapBuyProducts?.length ? swapBuyProducts.splice(0, length) : undefined
  }

  /** 添加、删除满送餐品 */
  autoFullNFree () {
    setTimeout(async () => {
      each(this.cartItems, (cartItem) => {
        const pk = cartItem.pk
        const itemPlan = (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[pk]) || null
        const fullItemNFree = get(discountMobx.discountResult?.fullItemNFreeMap, pk)
        if (fullItemNFree) {
          let isChanged = false // 标记购物车项是否变化
          const cloneCartItem = cloneDeep(cartItem)
          let { maxFreeCnt } = fullItemNFree
          const feeCnt = cartItem.fullItemNFreeProducts?.length ? cartItem.fullItemNFreeProducts.reduce((t, c) => t + c.cnt, 0) : 0
          delete cloneCartItem.fullItemNFreeProducts
          delete cloneCartItem.swapBuyProducts
          runInAction(() => {
            if (restaurantConfig.app === 'pos') {
              const isInvalidCount = doProductMobx.checkInvalidByProductNo(cartItem.productNo, cartItem.scaleNo, cartItem.cnt + feeCnt, cartItem.cnt + maxFreeCnt)
              if (isInvalidCount) {
                isChanged = true
                maxFreeCnt = maxFreeCnt - isInvalidCount
                cartItem.lackFullItemNFreeProducts = i18n.t('saleOut.lackFullFreeItems', {
                  count: isInvalidCount,
                  activeName: cartItem.name
                })
              }
            }
            if (maxFreeCnt > feeCnt) {
              isChanged = true
              cartItem.fullItemNFreeProducts = cartItem.fullItemNFreeProducts || []
              const fullItem = () => ({ ...cloneCartItem, parentPk: pk, cnt: 1, pk: doPk() })

              // 店长端合并显示满送
              if (restaurantConfig.app === 'pos' && restaurantConfig.autoMergeCartItem) {
                cartItem.fullItemNFreeProducts = []
                cartItem.fullItemNFreeProducts.push({ ...(fullItem()), cnt: (maxFreeCnt) })
              } else {
                for (let i = 0; i < maxFreeCnt - feeCnt; i++) {
                  cartItem.fullItemNFreeProducts?.push(fullItem())
                }
              }
            } else if (feeCnt && feeCnt > maxFreeCnt) {
              isChanged = true
              cartItem.fullItemNFreeProducts = cartItem.fullItemNFreeProducts?.splice(0, maxFreeCnt)
              cartItem.lackFullItemNFreeProducts = undefined
            }
          })
          if (isChanged) {
            restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
              type: 'change',
              cartItem,
              itemPlan,
              notCalcCart: true
            })
          }
        } else if (cartItem.fullItemNFreeProducts) {
          runInAction(() => {
            delete cartItem.fullItemNFreeProducts
            cartItem.lackFullItemNFreeProducts = undefined
          })
          restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
            type: 'change',
            cartItem,
            itemPlan,
            notCalcCart: true
          })
        }
      })
    })
  }

  /** 修改满送餐品 */
  addFullNFreeToCart (doProduct: IDoProduct, parentCartItemPk?: string): TSaveCartError | undefined {
    if (!parentCartItemPk) {
      return
    }
    const itemPlan = (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[parentCartItemPk]) || null
    const pk = doProduct.pk
    const productNo = doProduct.no
    const scaleNo = doProduct.scaleNo || '0'
    const isTogo = doProduct.isTogo
    const modifierGroups = convertDoModifierGroupsToModifierGroups(doProduct.modifierGroups)
    const addUserId = doProduct.addUserId || restaurantConfig?.member?.key || ''
    const startTime = doProduct.startTime
    const fkey = createFkey({ productNo, scaleNo, modifierGroups, addUserId, isTogo, startTime, isSeat: doProduct.seat || '-1', isOrderSwapBuy: doProduct.isOrderSwapBuy })
    const parentCartItem = this.cartItems?.find(item => item.pk === parentCartItemPk)
    const cartItem = parentCartItem?.fullItemNFreeProducts?.find(item => item.pk === pk)
    if (parentCartItem && cartItem) {
      cartItem.fkey = fkey
      cartItem.modifierGroups = modifierGroups
      const parentCartItemIndex = this.cartItems.findIndex(item => item.pk === parentCartItemPk)
      this.cartItems.splice(parentCartItemIndex, 1, parentCartItem)
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: parentCartItem,
        itemPlan
      })
      // 自动计算满送
      // this.autoFullNFree()
    }
  }

  /** 安全清空（不会发出清空购物车的事件） */
  safeClear () {
    this.cartItems = []
  }

  /** 直接修改餐品数量 */
  setCartItemCnt (cartItem: ICartItem | string, cnt: number) {
    if (!cnt) {
      this.remove(cartItem)
    } else {
      const handledCartItem = this.cartItems.find(item => item.fkey === (typeof cartItem === 'string' ? cartItem : cartItem.fkey))
      if (handledCartItem) {
        handledCartItem.cnt = cnt
        handledCartItem.swapBuyProducts = reduceSwapBuy({
          swapBuyProducts: handledCartItem.swapBuyProducts,
          length: handledCartItem.cnt
        })
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'change',
          cartItem: handledCartItem
        })
        // 自动计算满送
        // this.autoFullNFree()
      }
    }
  }

  async rejectOrders (params: {
    ordersId: string;
    cancelReason: string;
    addUserId: string;
    addUserName: string;
  }) {
    try {
      const data = await OrderAPI.rejectOrders({
        ...params,
      })
      return data
    } catch (err) {
    }
  }
  /** 设置购物车项预约时间 */
  setCartItemStartTime (cartItem: IViewCartItem | string, startTime?: string, pickTimeRange?: any) {
    const theCartItem = this.cartItems.find(item => item.fkey === (typeof cartItem === 'string' ? cartItem : cartItem.fkey))
    if (theCartItem) {
      theCartItem.startTime = startTime
      theCartItem.pickTimeRange = pickTimeRange
      if (theCartItem.fullItemNFreeProducts?.length) {
        theCartItem.fullItemNFreeProducts.forEach(item => {
          item.startTime = startTime
          item.pickTimeRange = pickTimeRange
        })
      }
      if (theCartItem.productGroups?.length) {
        theCartItem.productGroups.forEach(group => {
          group.productGroupDetails?.forEach(item => {
            item.startTime = startTime
            item.pickTimeRange = pickTimeRange
          })
        })
      }
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
        type: 'change',
        cartItem: theCartItem
      })
    }
  }

  /** 设置联系人信息 */
  setContact (data?: {
    contactName?: string;
    contactMobile?: string;
    contactAddress?: string;
    contactApt?: string;
    contactEmail?: string;
    countryCode?: string;
    contactInfo?: any;
    carNo?: string;
  }) {
    if (data) {
      this.info.contactName = data.contactName ?? (this.info.contactName || '')
      this.info.contactMobile = data.contactMobile ?? (this.info.contactMobile || '')
      this.info.contactAddress = data.contactAddress ?? (this.info.contactAddress || '')
      this.info.contactApt = data.contactApt ?? (this.info.contactApt || '')
      this.info.contactEmail = data.contactEmail ?? (this.info.contactEmail || '')
      this.info.countryCode = data.countryCode ?? (this.info.countryCode || '')
      this.info.contactInfo = data.contactInfo ?? (this.info.contactInfo || {})
      this.info.carNo = data.carNo ?? (this.info.carNo || '')
    } else {
      this.info.contactName = ''
      this.info.contactMobile = ''
      this.info.contactAddress = ''
      this.info.contactApt = ''
      this.info.contactEmail = ''
      this.info.countryCode = ''
      this.info.carNo = ''
      this.info.contactInfo = {}
    }
    restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
  }

  /** 更新联系人信息 */
  updateContact (data?: {
    contactName?: string;
    contactMobile?: string;
    contactAddress?: string;
    contactApt?: string;
    contactEmail?: string;
    contactInfo?: any;
    carNo?: string;
  }) {
    this.setContact(data)
    if (this.ordersId) {
      orderMobx.update({
        contactName: this.info.contactName,
        contactMobile: this.info.contactMobile,
        contactInfo: JSON.stringify({ ...(this.info.contactInfo || {}), address: this.info.contactAddress, apt: this.info.contactApt, email: this.info.contactEmail }),
        ordersId: this.ordersId
      })
    } else {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
    }
  }
  setOrderExpressPrice (order: IOrder) {
    if (order.channel === 'callPos' && order.eatType === 'delivery') {
      order.detailList.forEach(i => {
        if (i.itemType === 'express') {
          this.info.express = { ...this.info.express, updateDetailId: i.detailId }
          this.setExpressPrice(i.paidFee, true)
        }
      })
    }
  }

  setEatType (eatType: TEatType, params?: { handler?: boolean; isForce?: boolean; isSync?: boolean /* 是否不触发事件 */ }) {
    let isForce = params?.isForce
    let isSync = params?.isSync
    // 异常数据拦截
    if (eatType && !['dinein', 'togo', 'delivery', 'pickup', 'carside'].includes(eatType)) {
      isForce = true
      eatType = restaurantConfig.codeType === 'brand' ? 'pickup' : 'dinein'
    }
    /** 就餐人数, 非堂食自动切换默认就餐方式 */
    if (eatType && !['dinein'].includes(eatType) && !this.info.person) {
      this.setPerson(1)
    }
    if (restaurantConfig.app === 'mobile') {
      // 无就餐方式不能切换
      if (!eatType) return
      // 后付费已下单不能切换
      if (!!this.ordersId && !!this.info.payMode && !isForce) return
    }
    if (this.info.eatType !== eatType) {
      if (eatType !== 'dinein') {
        this.cartItems.forEach(item => {
          item.isTogo = 0
          item.swapBuyProducts?.forEach(swapItem => {
            swapItem.isTogo = 0
          })
          item.fullItemNFreeProducts?.forEach(fullNFreeItem => {
            fullNFreeItem.isTogo = 0
          })
          item.productGroups?.forEach(group => {
            group.productGroupDetails?.forEach(product => {
              product.isTogo = 0
            })
          })
        })
      }
      this.info.eatType = eatType
      // 已存在订单不支持更改点餐类型
      if ((!this.ordersId && orderMobx.viewOrder.eatType) || restaurantConfig.app !== 'mobile') {
        /** 切换mpc的点餐类型 */
        discountMobx.switchEatType(eatType)
      }
      if (!isSync) {
        restaurantCenter.emit(RESTAURANT_EVENT.EAT_TYPE_CHANGE, {
          eatType,
          fromHandler: !!params?.handler
        })
      }
    }
    this.packAll(eatType !== 'dinein' ? 1 : 0)
  }

  setAppType (appType: TAppType) {
    this.info.appType = appType
    if (appType === '3rdapp') {
      this.info.payMode = 0
    }
  }

  setRemark (remark?: string, fromSync = false) {
    this.info.remark = remark || ''
    restaurantCenter.emit(RESTAURANT_EVENT.CART_INFO_CHANGED, {
      remark: this.info.remark,
      fromSync
    })
    restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
  }

  setPerson (person: number, fromSync?: boolean) {
    this.info.person = person
    if (this.ordersId && !fromSync) {
      orderMobx.update({
        ordersId: this.ordersId,
        person
      })
    } else {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
    }
  }

  setBySeat (handler: boolean) {
    this.info.openBySeat = handler
  }

  setSeatInfo (seatInfo: ISeatInfo) {
    this.info.seatInfo = seatInfo
  }

  setKidsPerson (cnt: number) {
    this.info.kids = cnt
    if (this.ordersId) {
      orderMobx.update({
        ordersId: this.ordersId,
        kids: cnt
      })
    } else {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
    }
  }

  setJiuCanNum (person: number, kids: number, fromSync?: boolean) {
    this.info.person = person
    this.info.kids = kids
    if (this.ordersId && !fromSync) {
      orderMobx.update({
        ordersId: this.ordersId,
        person,
        kids
      })
    } else {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_PREORDER_INFO_CHANGED)
    }
    restaurantCenter.emit(RESTAURANT_EVENT.EATING_PERSON_CHANGE, { data: { cnt: person, kids } })
  }

  setTableCode (tableCode: string) {
    if (this.info.tableCode !== tableCode) {
      this.info.tableCode = tableCode
      if (this.ordersId) {
        // TODO 处理修改异常的case
        if (restaurantConfig.app === 'pos') {
          // orderMobx.updateTable({
          //   ordersId: this.ordersId,
          //   tableCode: tableCode,
          //   tableAlias: deskMobx.tableCodeToTableAliasMap[tableCode]
          // })
          this.setChangeTablesWithOrders({
            tableCode: tableCode
          })
        } else {
          if (!this.info.payMode) {
            orderMobx.update({
              ordersId: this.ordersId,
              tableCode: tableCode,
              tableAlias: deskMobx.tableCodeToTableAliasMap[tableCode]
            })
          }
        }
      }
    }
  }

  // 转台
  async setChangeTablesWithOrders (params: { tableCode: string; ordersIdB?: string; addUserName?: string }) {
    const { tableCode, ordersIdB, addUserName } = params
    if (this.info.tableCode !== tableCode) {
      this.info.tableCode = tableCode
      if (this.ordersId) {
        return OrderAPI.postChangeTableWithOrders({
          ordersId: this.ordersId,
          tableCode: tableCode,
          tableAlias: deskMobx.tableCodeToTableAliasMap[tableCode],
          ordersIdB,
          addUserName
        })
      }
    }
  }

  setTableTent (tableTent: string) {
    this.info.tableTent = tableTent
    if (this.ordersId) {
      // TODO 处理修改异常的case
      if (restaurantConfig.app === 'pos') {
        orderMobx.updateTable({
          ordersId: this.ordersId,
          tableTent: tableTent
        })
      } else {
        orderMobx.update({
          ordersId: this.ordersId,
          tableTent: tableTent
        })
      }
    }
  }

  /** spec 当payMode为2时会特殊的处理_payMode,而payMode依然为1 */
  setPayMode (payMode: 0 | 1 | 2) {
    console.log('payMode切换 ======>', payMode)
    this.info.payMode = payMode > 0 ? 1 : 0
    if (payMode === 2) {
      this.info._payMode = 2
    }
  }

  setSourceType (sourceType?: string | undefined | null) {
    this.info.sourceType = sourceType || undefined
  }

  setOrdersOutNo (ordersOutNo: string) {
    this.info.ordersOutNo = ordersOutNo
  }

  setStartTime (startTime?: string | null | undefined) {
    this.info.startTime = startTime || ''
  }

  setMenuTime (menuTime?: string | null | undefined) {
    this.info.menuTime = menuTime || ''
  }

  setAsapTime (asapTime?: string | null | undefined) {
    this.info.asapTime = asapTime || ''
  }

  setCityId (cityId?: number) {
    if (bo === 'cn') {
      return
    }
    this.info.cityId = cityId || 0
    restaurantCenter.emit(RESTAURANT_EVENT.CART_FEE_CITYID_CHANGED)
  }

  setCallId (callId?: number | null | undefined) {
    this.info.callId = callId || undefined
  }

  setOrdersPreId (ordersPreId?: string | null | undefined) {
    this.info.ordersPreId = ordersPreId || undefined
  }

  /** (合并分拆)购物车项，将会把购物车项合并/分拆 */
  mergeSplit ({ cartItem, count, discountTagId }: { cartItem: ICartItem; count: number; discountTagId?: number }) {
    if ((!restaurantConfig.autoMergeCartItem && (cartItem.cnt === 1 || count >= cartItem.cnt))) {
      return
    }
    const pkMap = keyBy(cartMobx.viewCartItems, 'pk')
    const viewCartItemsPkMap = keyBy(
      this.viewCartItems
        .filter((item: any) => item.fkey === cartItem.fkey)
        .filter((item: any) => !item.offItemPlanTagId || item.offItemPlanTagId === discountTagId)
      , 'pk')
    const appendCartItem = []
    const index = this.cartItems.findIndex(item => item.fkey === cartItem.fkey)
    if (restaurantConfig.autoMergeCartItem) {
      cartItem.cnt = cartMobx.cartItems
        .filter(item => item.fkey === cartItem.fkey)
        .filter((item: any) => !pkMap[item.pk].offItemPlanTagId || pkMap[item.pk].offItemPlanTagId === discountTagId)
        .reduce((prv, cartItem) => cartItem.cnt + prv, 0)
    }
    const totalCnt = cartItem.cnt
    cartItem.cnt = count
    // autoMergeCartItem
    if (restaurantConfig.autoMergeCartItem) {
      if (totalCnt - count) {
        const splitedCartItem = cloneDeep(cartItem)
        splitedCartItem.pk = doPk()
        splitedCartItem.cnt = totalCnt - count
        splitedCartItem.swapBuyProducts = reduceSwapBuy({
          swapBuyProducts: splitedCartItem.swapBuyProducts,
          length: splitedCartItem.cnt
        })
        appendCartItem.push(splitedCartItem)
      }
      if (cartItem.cnt) {
        const currentCartItem = cloneDeep(cartItem)
        const swapBuyProducts = flatten(this.cartItems
          .filter(item => item.fkey === cartItem.fkey && item.pk !== cartItem.pk)
          .filter((item: any) => !item.offItemPlanTagId || item.offItemPlanTagId === discountTagId)
          .map(item => item.swapBuyProducts || []))
        currentCartItem.swapBuyProducts = reduceSwapBuy({
          swapBuyProducts: [...currentCartItem.swapBuyProducts || [], ...swapBuyProducts],
          start: totalCnt - count,
          length: currentCartItem.cnt
        })
        appendCartItem.push(currentCartItem)
      }
      this.cartItems = this.cartItems.filter((item: any) => { return !viewCartItemsPkMap[item.pk] || item.fkey !== cartItem.fkey })
    } else {
      const splitedCartItem = cloneDeep(cartItem)
      splitedCartItem.pk = doPk()
      splitedCartItem.cnt = totalCnt - count
      splitedCartItem.swapBuyProducts = reduceSwapBuy({
        swapBuyProducts: splitedCartItem.swapBuyProducts,
        length: splitedCartItem.cnt
      })
      appendCartItem.push(splitedCartItem)
    }
    this.cartItems.splice(index, 0, ...appendCartItem)
    // TODO 分发购物车item项的相应事件
    return appendCartItem
  }

  /** 设置团餐信息 */
  setGroupMealInfo (info: IGroupMealInfo) {
    const contactInfo = pick(info, 'contactAddress', 'contactApt', 'contactMobile', 'contactName')
    if (contactInfo.contactMobile !== this.info.contactMobile) {
      this.setContactUpdate(true)
    }
    this.setContact(pick(info, 'contactAddress', 'contactApt', 'contactMobile', 'contactName'))
    discountMobx.calcMenu()
    this.info.ordersOutNo = info.ordersOutNo
    info.eatType && cartMobx.setEatType(info.eatType)
    if (this.ordersId) {
      // 如果是订单同步
      orderMobx.update({
        contactName: this.info.contactName,
        contactMobile: this.info.contactMobile,
        ordersOutNo: this.info.ordersOutNo,
        contactInfo: JSON.stringify({ ...this.info.contactInfo || {}, address: this.info.contactAddress, apt: this.info.contactApt }),
        ordersId: this.ordersId
      })
    }
  }

  /** 设置三方外卖信息 */
  setDeliveryInfo (info: IThirdDeliveryInfo) {
    this.setContact(pick(info, 'contactAddress', 'contactApt', 'contactMobile', 'contactName'))
    discountMobx.calcMenu()
    this.info.ordersOutNo = info.ordersOutNo
    this.info.sourceType = info.sourceType
    info.eatType && cartMobx.setEatType(info.eatType)
    if (this.ordersId) {
      // 如果是订单同步
      orderMobx.update({
        contactName: this.info.contactName,
        contactMobile: this.info.contactMobile,
        ordersOutNo: this.info.ordersOutNo,
        sourceType: this.info.sourceType,
        contactInfo: JSON.stringify({ ...this.info.contactInfo || {}, address: this.info.contactAddress, apt: this.info.contactApt }),
        ordersId: this.ordersId
      })
    }
  }

  /** 设置自营外卖收货信息 */
  setDeliveryAddressInfo (eatType: TEatType, info?: IDeliveryAddressInfo) {
    if (info) {
      this.setContact(pick(info, 'contactAddress', 'contactMobile', 'contactName', 'contactInfo'))
    } else {
      this.setContact()
    }
    this.setEatType(eatType)
  }

  /** 设置配送费 */
  setExpressPrice (expressPrice?: number, isSkipSetStore?: boolean) {
    this.info.express = this.info.express || {}
    this.info.express.pk = this.info.express.pk || doPk()
    this.info.express.price = expressPrice
    if (restaurantConfig.app === 'pos' && !isSkipSetStore) {
      const expressStoreKey = 'pos-callPos-delivery-express-price'
      !expressPrice?.toString() ? (this.info.express.price = store.get(expressStoreKey)) : store.set(expressStoreKey, expressPrice || 0)
    }
    if (!this.info.expressList?.length) {
      this.setExpressList()
    }
  }

  setExpressList () {
    if (this.info.eatType !== 'delivery') return
    const express = this.info.express || { price: 0 }
    // 通过startTime字符串判断是否切换预约时间
    const _hashCartStartTimes = this.info.expressList?.length ? `${(this.info.expressList || []).map((item) => item.startTime).join('')}_${this.info.expressList?.[0].price}` : 'none'
    const hashCartStartTimes = `${this.cartStartTimes.join('')}_${express.price}`
    console.log(_hashCartStartTimes, hashCartStartTimes)
    if (this.info.express && _hashCartStartTimes !== hashCartStartTimes) {
      console.log('🍰hash不一致，需要更新配送费', _hashCartStartTimes, hashCartStartTimes)
      if (this.cartStartTimes.length) {
        const expressList = map(this.cartStartTimes, (startTime: string, index: number) => {
          return {
            pk: `${express.pk || doPk()}_${index}`,
            price: express.price,
            startTime
          }
        })
        this.info.expressList = [...expressList]
      } else {
        this.info.expressList = [express]
      }
    }
  }

  /** 设置预计配送时间 */
  setDeliveryInTime (deliveryInTime?: number) {
    this.info.deliveryInTime = deliveryInTime
    restaurantCenter.emit(RESTAURANT_EVENT.CART_EXPRESS_TIME_CHANGED)
  }

  /** 重置购物车，将清空购物车，同时重置购物车信息 */
  reset (payMode?: 0 | 1, eatType?: TEatType) {
    if (restaurantCenter.config.currentPath === 'pickup') {
      payMode = 0
      eatType = 'pickup'
    }
    this.info = getCartInitialInfo(payMode, eatType)
    this.clearOrdersId()
    this.clear()
    this.setOrdersPreId()
    this.lastHash = ''
    // this.lastUpdated = 0
    restaurantCenter.emit(RESTAURANT_EVENT.CART_RESET)
  }

  /** 保留购物车部分数据， 清空购物车 */
  clearPart (clearData: any) {
    this.clear()
    this.info = { ...this.info, ...clearData }
  }

  /**
   * 过滤不合法的挂单数据
   * 1，上限9个，超过自动删除最早一单
   * 2，挂单信息仅保留一天，过营业时间重置，全部清空当前 */
  filterTemporary (): ICartCopy[] {
    const storeKey = 'eshine-tabletop-cart-depot'
    store.set(storeKey, filter(store.get(storeKey) || [], (item: any) => item.createTime + 24 * 60 * 60 * 1000 > Date.now()))
    return store.get(storeKey) || []
  }

  /** 获取一份当前购物车的copy，不包含已下单餐品 */
  getCopy (isClone: boolean = true): ICartCopy {
    return {
      cartItems: isClone ? cloneDeep(this.cartItems) : this.cartItems,
      info: isClone ? cloneDeep(this.info) : this.info,
      pk: doPk(),
      ordersId: this.ordersId,
      createTime: Date.now(),
      subject: this.cartItems.map((cartItem) => cartItem.name).join(';'),
      memberId: discountMobx.discountResult.memberId,
      discountAction: pick<IDiscountAction>(discountMobx.discountAction, 'orderPlan', 'itemPlan'),
      memberGroupId: discountMobx.discountResult.memberCardId
    }
  }

  /** 根据一份clone的副本还原购物车 */
  async restoreByCopy (cartCopy: ICartCopy, isRestInfo: boolean = true) {
    setTimeout(async () => {
      runInAction(() => {
        this.cartItems = resetRestoreCartItems(this.info, cartCopy.cartItems)
        if (isRestInfo) {
          this.info = cartCopy.info
        }
        cartCopy.discountAction?.orderPlan && discountMobx.setOrderPlan(cartCopy.discountAction.orderPlan)
        Object.entries(cartCopy.discountAction?.itemPlan || []).forEach(([pk, data]) => discountMobx.setItemPlan(pk, data, true))
      })
    }, 100)
  }

  /** 购物车挂单，将购物车信息存储到cartDepot */
  saveTemporary () {
    if (!this.cartItems.length) {
      return
    }
    // 获取缓存的有效挂单
    const hasTemporaryOrder = this.filterTemporary()
    if ((hasTemporaryOrder || []).length === 9) {
      return 'isFull'
    }
    store.set('eshine-tabletop-cart-depot', [this.getCopy()].concat(this.filterTemporary()).slice(-9))
    this.clear()
  }

  /** 购物车取单，指定一个存储的fkey，然后将购物车信息还原到购物车，如果当前购物车有信息将自动挂单到仓库 */
  fetchTemporary (pk: string) {
    // 取单前会自动挂单
    this.saveTemporary()
    const cartDataIndex = this.filterTemporary().findIndex(cart => cart.pk === pk)
    if (~cartDataIndex) {
      const cartDepot = this.filterTemporary().splice(cartDataIndex, 1)[0]
      this.restoreByCopy(cartDepot)
      this.deleteTemporary(pk)
      return cartDepot
    }
  }

  /** 删除购物车仓库 */
  deleteTemporary (pk: string) {
    store.set('eshine-tabletop-cart-depot', this.filterTemporary().filter(cart => cart.pk !== pk))
  }

  /** 删除购物车仓库 by OrdersId */
  deleteTemporaryByOrdersId (ordersId: string) {
    store.set('eshine-tabletop-cart-depot', this.filterTemporary().filter(cart => !cart.ordersId || cart.ordersId !== ordersId))
  }

  /** 设置购物车某个购物项打包/堂食 */
  switchTogo (cartItem: ICartItem | string) {
    if (this.info.eatType !== 'dinein') {
      return
    }
    const theCartItem = this.cartItems.find(item => item.fkey === (typeof cartItem === 'string' ? cartItem : cartItem.fkey))
    if (theCartItem) {
      const theTogoFlag = theCartItem.isTogo === 1 ? 0 : 1
      theCartItem.isTogo = theTogoFlag
      // 处理套餐
      if (theCartItem.productGroups) {
        theCartItem.productGroups.forEach(groups => {
          groups.productGroupDetails.forEach(product => (product.isTogo = theTogoFlag))
        })
      }
    }
  }

  /** 设置延迟打印 */
  setStartTimeOffset (cartItem: IViewCartItem | string, startTimeOffset: number) {
    const theCartItem = this.cartItems.find(item => item.fkey === (typeof cartItem === 'string' ? cartItem : cartItem.fkey))
    if (theCartItem) {
      theCartItem.startTimeOffset = startTimeOffset
    }
  }

  /** 批量设置延迟打印 */
  setItemsStartTimeOffset (delayData: { [pk: string]: number }) {
    this.cartItems.forEach(cartItem => {
      if (delayData[cartItem.pk] !== undefined) {
        cartItem.startTimeOffset = delayData[cartItem.pk]
      }
    })
  }

  /** 清除已失效的餐品 */
  clearDisabledItems () {
    this.cartItems = this.cartItems.filter((item: any) => {
      const cur = this.viewCartItems.find((v: any) => v.pk === item.pk)
      return cur && !cur.disabled
    })
  }

  /** 还原订单信息到购物车 */
  restoreOrderInfo () {
    this.info.kids = orderMobx.viewOrder.kids
    this.info.person = orderMobx.viewOrder.person
    this.info.remark = orderMobx.viewOrder.remark
    this.info.tableCode = orderMobx.viewOrder.tableCode
    this.info.tableAlias = orderMobx.viewOrder.tableAlias
    this.info.tableTent = orderMobx.viewOrder.tableTent
    this.info.payMode = orderMobx.viewOrder.payMode
    this.info.contactName = orderMobx.viewOrder.contactName
    this.info.contactMobile = orderMobx.viewOrder.contactMobile
    if (orderMobx.viewOrder.callId) {
      this.info.callId = orderMobx.viewOrder.callId
    }
    if (orderMobx.viewOrder.ordersPreId) {
      this.info.ordersPreId = orderMobx.viewOrder.ordersPreId
    }
    const contactInfo = parseString(orderMobx.viewOrder.contactInfo || '{}')
    if (restaurantConfig.app === 'mobile') {
      this.info.contactInfo = contactInfo
    }
    this.info.contactAddress = contactInfo?.address || ''
    this.info.contactApt = contactInfo?.apt || ''
    this.info.contactEmail = contactInfo?.email || ''
    // 对接三方外卖
    this.info.sourceType = orderMobx.viewOrder.sourceType
    this.info.ordersOutNo = orderMobx.viewOrder.ordersOutNo
    this.setEatType(orderMobx.viewOrder.eatType, { isForce: true })
    this.setOrderExpressPrice(orderMobx.order)
    this.setCityId(contactInfo?.cityId)
    // 还原优惠
    if (orderMobx.viewOrder.discountList) {
      discountMobx.restoreDiscountAction(orderMobx.viewOrder.discountList)
    } else {
      discountMobx.clearDiscountAction()
    }
    // 还原免税
    const freeTaxList: number[] = []
    if (orderMobx.viewOrder.freeTax > 0) {
      this.viewOrderItems.forEach(orderItem => {
        if (orderItem.freeTax > 0) {
          if (!freeTaxList.includes(orderItem.taxCategoryId)) {
            freeTaxList.push(orderItem.taxCategoryId)
          }
        }
      })
    }
    this.info.freeTaxList = freeTaxList
    // 处理未接单的订单（其中可能包含未接单的餐品，将还原回购物车）
    if (orderMobx.viewOrder.isWait && orderMobx.viewOrder.ordersCart) {
      this.cartItems = orderMobx.viewOrder.ordersCart.map(this.convertSaveItemToCartItem)
    }
    if (restaurantConfig.app === 'pos' && orderMobx.viewOrder.isCreditCardFirst) {
      this.info._payMode = 2
      this.info.tableTent = orderMobx.viewOrder.tableTent || ''
    }
    productMobx.setChannel(orderMobx.viewOrder.channel)
  }

  /** 设置订单id到购物车，购物车会自动计算当前该订单的数据 */
  setOrdersId (ordersId: string): Promise<any> {
    this.ordersId = ordersId
    // 先付费到此为此
    // if (!this.info.payMode) {
    //   return Promise.resolve()
    // }
    // 引发order mobx的数据模型的变化
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.ORDER_GET_START, { ordersId })
    return orderMobx.init(ordersId, { showOrderCart: true }).then((res) => {
      // pos快速下单需要切换付费类型
      if (res?.channel === TEChannel.Pos) {
        this.setPayMode(res.payMode)
      }
      restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.ORDER_GET_END, { ordersId })
      // 从order 搬运到cart
      runInAction(() => {
        // 如果从订单还原回来的时候 需要重置原先购物车的餐品
        if (restaurantConfig.app === 'pos') {
          // 20210514 去除自动清空
          this.cartItems = []
        }
        this.restoreOrderInfo()
      })
    })
  }

  /** 同步把当前的订单放回到购物车中，不需要再次重新获取 */
  setOrder () {
    if (orderMobx.order.ordersId) {
      this.ordersId = orderMobx.order.ordersId
      this.restoreOrderInfo()
      this.setOrderWaitingAccepted(orderMobx.order)
    }
  }

  /** 设置预订单数据到购物车 */
  setPreOrdersData (ordersData: any) {
    orderMobx.initPreOrderData(ordersData).then(() => {
      this.restoreOrderInfo()
      orderMobx.reset()
    })
  }

  /** 订单监听 */
  setOrderWaitingAccepted (order: IOrder) {
    // 桌码有websocket监听订单和购物车，其余后付费需要自动监听
    if (restaurantConfig.app === 'mobile' && order.payMode && order.channel !== 'mobile') {
      if (order.status !== 'NotAccepted') {
        // 接单后要清除购物车
        this.clear()
      }
      if (order.status === 'NotAccepted' || order.status === 'Pending') {
        restaurantCenter.emit(RESTAURANT_EVENT.ORDER_WAITING_ACCEPTED, {
          order: order,
        })
      }
    }
  }

  /** 清楚购物车订单id */
  clearOrdersId () {
    this.ordersId = ''
  }

  /** 获取下单信息 */
  private getSaveInfo () {
    const saveData: any = {}
    const baseConfig = restaurantConfig.app === 'pos' ? {
      addUserId: restaurantConfig.managerId,
      addUserName: restaurantConfig.managerName,
      managerId: restaurantConfig.managerId,
      managerName: restaurantConfig.managerName,
      deviceId: restaurantConfig.deviceId,
      sourceType: restaurantConfig.sourceType || this.info.sourceType || 'pos',
      ordersOutNo: this.info.ordersOutNo || '',
    } : restaurantConfig.app === 'kiosk' ? {
      sourceType: restaurantConfig.sourceType || this.info.sourceType || 'kiosk',
      deviceId: restaurantConfig.deviceId,
    } : {
      startTime: undefined,
      deviceId: 'mobile',
      // 推广链接当前放置在sourceType中, 当前门店码和桌码归为 scanQRcode
      sourceType: restaurantConfig.sourceType || ((restaurantConfig.codeType === 'brand' || restaurantConfig.codeType === 'store') && storeMobx.info.storeOrderType ? 'onlineMobileSpecial' : restaurantConfig.codeType === 'brand' ? 'onlineMobileWebH5' : 'scanQRcode'),
      brandPromotionId: restaurantConfig.promotionId || undefined
    }
    const mktFee = toDecimal(this.cartResult.totalDiscountPrice)
    const contactInfoObj: any = {
      ...(this.info.contactInfo || {})
    }
    if (this.info.contactAddress) {
      contactInfoObj.address = this.info.contactAddress
    }
    if (this.info.contactApt) {
      contactInfoObj.apt = this.info.contactApt
    }
    if (this.info.carNo) {
      contactInfoObj.carNo = this.info.carNo
    }
    if (restaurantConfig.member?.mobile) {
      contactInfoObj.memberMobile = restaurantConfig.member.mobile
    }
    if (this.info.cityId) {
      contactInfoObj.cityId = this.info.cityId
    }
    if (restaurantConfig.member?.email) {
      contactInfoObj.memberEmail = restaurantConfig.member.email
    }
    saveData.infos = Object.assign(baseConfig, {
      channel: this.channel,
      appType: productMobx.channel === '3rdDelivery' ? '3rdapp' : restaurantConfig.app,
      // appType: productMobx.channel === '3rdDelivery' ? '3rdapp' : restaurantConfig.app === 'pos' ? 'pos' : productMobx.channel,
      memberId: discountMobx.discountResult.memberId ? discountMobx.discountResult.memberId.toString() : restaurantConfig.mpc?.member?.memberId ? restaurantConfig.mpc?.member?.memberId.toString() : restaurantConfig.member?.id || '0',
      memberGroupId: discountMobx.discountResult.memberCardId ? discountMobx.discountResult.memberCardId.toString() : restaurantConfig.mpc?.optMemberCard?.memberCardId ? restaurantConfig.mpc?.optMemberCard?.memberCardId.toString() : '0',
      eatType: this.info.eatType,
      ordersType: 'dc',
      bo,
      brandId: storeMobx.info.brandId || restaurantConfig.brandId || ((window as any)?.storeInfo as any)?.brandId,
      storeId: storeMobx.info.storeId || restaurantConfig.storeId || ((window as any)?.storeInfo as any)?.storeId,
      currency: bo === 'cn' ? 'RMB' : bo === 'de' ? 'EUR' : 'USD',
      tableAlias: deskMobx.tableCodeToTableAliasMap[this.info.tableCode] || this.cartResult.tableAlias,
      tableCode: this.info.tableCode,
      tableTent: this.info.tableTent,
      isTogo: this.cartResult.isTogo,
      payMode: this.info.payMode > 0 ? 1 : 0,
      person: this.info.person,
      kids: this.info.kids || 0,
      startTime: this.getFirstStartTimeFromProductRule || undefined,
      menuTime: this.info.menuTime || undefined,
      originalFee: toDecimal(this.cartResult.totalOriginalPrice),
      paidFee: toDecimal(this.cartResult.totalPrice - this.cartResult.tax),
      mktFee,
      sk: mktFee > 0, // TODO: 未来要去掉
      subject: storeMobx.info.storeName + ' - ' + (restaurantConfig.bo === 'cn' ? '点餐' : restaurantConfig.bo === 'de' ? 'Bestellen' : 'Order'),
      tax: this.cartResult.tax,
      freeTax: this.cartResult.freeTax,
      serviceCharge: this.cartResult.serviceCharge,
      box: this.cartResult.boxPrice,
      // express: this.cartResult.expressPrice,
      ordersId: this.ordersId,
      remark: this.info.remark,
      contactInfo: JSON.stringify(contactInfoObj),
      contactMobile: this.info.contactMobile,
      contactName: this.info.contactName,
      freeTaxCategoryList: this.info.freeTaxList.map(i => i.toString()),
      openId: ['mobile'].includes(restaurantConfig.app) ? restaurantConfig?.member?.openId : undefined,
      menuType: ['mobile'].includes(restaurantConfig.app) ? (restaurantConfig.codeType === 'brand' && this.info.eatType !== 'dinein' ? 'pickup' : 'mobile') : undefined,
      callId: this.info.callId,
    })
    // 用户与门店的距离
    if (this.info.distance) {
      saveData.infos.locDistance = this.info.distance
    }
    // 已存在订单不支持更改点餐类型
    if (this.ordersId && orderMobx.viewOrder.eatType) {
      saveData.infos.eatType = orderMobx.viewOrder.eatType
    }
    // eatType 异常处理
    if (!['dinein', 'togo', 'delivery', 'pickup', 'carside'].includes(saveData.infos.eatType)) {
      saveData.infos.eatType = restaurantConfig.codeType === 'brand' ? 'pickup' : 'dinein'
    }
    if (this.info.appType === '3rdapp') {
      saveData.discount = { closeActivity: true }
    } else {
      saveData.discount = Object.assign(
        {
          sk: discountMobx.discountResult.sk,
          version: discountMobx.discountResult.version,
          startTime: this.getFirstStartTimeFromProductRule || undefined
        },
        discountMobx.actionPlan
      )
    }
    if (this.info.eatType === 'delivery') {
      saveData.infos.deliveryInTime = this.info.deliveryInTime
    } else {
      saveData.infos.deliveryInTime = undefined
    }
    if (this.info.ordersPreId) {
      saveData.ordersPreId = this.info.ordersPreId
    }
    // 品牌码堂食
    if (restaurantConfig.app === 'mobile' && restaurantConfig.codeType === 'brand' && saveData.infos.eatType === 'dinein') {
      saveData.infos.diningMode = storeMobx.storeSceneConfig?.diningMode
    } else {
      delete saveData.infos.diningMode
    }
    // 扫码类型
    if (restaurantConfig.app === 'mobile') {
      saveData.infos.scanType = restaurantConfig.codeType
    }
    // 记录当前订单的状态使用虚拟的状态isWait 主要区别是后付费加菜还是后付费重新下菜
    saveData.isWait = this.isWait
    // 处理payMode 2的特殊case，即时变成后付费的模式
    if (restaurantConfig.app === 'pos' && this.info._payMode === 2) {
      saveData.infos.prePayType = 'bankCard'
    }
    // POS传posMemberId、posMemberGroupId
    if (restaurantConfig.app === 'pos' && this.info.payMode) {
      saveData.infos.posMemberId = saveData.infos.memberId
      saveData.infos.posMemberGroupId = saveData.infos.memberGroupId
    }
    // // cityId(计税用)
    // if (this.info.cityId) {
    //   saveData.infos.cityId = this.info.cityId
    // }
    return saveData
  }

  /** 获取快递费购物车项 */
  getExpress (express?: IExpressInfo) {
    const _express = express || cartMobx.info?.express
    return {
      pk: _express?.pk,
      type: 'express',
      updateDetailId: _express?.updateDetailId,
      paidFee: _express?.price || 0,
      originalFee: _express?.price || 0,
      startTime: _express?.startTime || cartMobx.info.startTime,
    }
  }

  /** 更新配送费 */
  updateExpress () {
    let saveData = this.getSaveInfo()
    saveData.ordersDetails = getOrderDetails(this.cartResult, this.viewCartItems, this.info)
    saveData.ordersDetails.push(this.getExpress() as any)
    return OrderAPI.updateExpress(saveData)
  }

  /** 预下单数据 */
  getPreSaveData () {
    let saveData = this.getSaveInfo()
    saveData.ordersDetails = getOrderDetails(this.cartResult, this.viewCartItems, this.info)
    return saveData
  }

  /**
   * 下单:
   * isReject: 后付费二次确认拒绝加菜
   */
  async save (isReject?: boolean): Promise<IOrder> {
    // 先付费已下单取消订单重新下单
    if (restaurantConfig.app === 'mobile' && !this.info.payMode && this.ordersId && !restaurantConfig.buyTogetherId) {
      const order = orderMobx.viewOrder
      const canCancel = ['Pending', 'NotAccepted'].includes(order?.status)
      if (canCancel) {
        const success = await this.cancel()
        success && this.clearOrdersId()
        success && cartMobx.replacePk()
      }
    }
    if (this.cartResult.presentTotalCnt || (this.ordersId && this.isWait)) {
      if (!this.info.payMode && this.ordersId) {
        if (this.lastHash === this.getHash()) {
          return this.syncMkt().then(() => {
            return orderMobx.order
          })
        }
      }
      if (restaurantConfig.codeType === 'table' && !(deskMobx.tableCodeToTableAliasMap[this.info.tableCode] || this.cartResult.tableAlias)) {
        await deskMobx.init()
      }
      // pos和mobile在下单中有差异部分顾现处理差异部分
      let saveData = this.getSaveInfo()
      saveData.ordersDetails = getOrderDetails(this.cartResult, this.viewCartItems, this.info)
      if (!cartMobx.ordersId && cartMobx.info.eatType === 'delivery') {
        if (this.info.expressList?.length) {
          // 添加
          forEach(this.info.expressList, (item) => {
            saveData.ordersDetails.push(this.getExpress(item) as any)
          })
        } else {
          saveData.ordersDetails.push(this.getExpress(this.info.express) as any)
        }
      }
      // pos场景bug兜底，误传channel
      if (restaurantConfig.app === 'pos' && saveData?.infos.channel === 'meituan') {
        saveData.infos.channel = 'pos'
      }
      // pos场景bug兜底，误传channel
      if (restaurantConfig.app === 'pos' && saveData?.infos.channel === 'eleme') {
        saveData.infos.channel = 'pos'
      }
      // kiosk
      if (restaurantConfig.app === 'kiosk') {
        saveData.infos.channel = 'kiosk'
      }
      if (isReject) {
        // 后付费拒绝加菜清空当前餐品明细
        saveData.ordersDetails = []
      }
      /** TODO 1121后删除 用于兼容后端灰度 =>> 订单增加后厨排队时长计算 */
      saveData.infos = {
        ...saveData.infos,
        hasPaiduiTime: 1
      }
      console.log('🚀saveOrder', saveData)
      return OrderAPI.save(saveData).then((res: any) => {
        if (res?.result) {
          if (!this.info.payMode) {
            // 制作一个当前购物车的刻度
            this.makeHash()
          }
          runInAction(() => {
            orderMobx.restore(res.result)
            // TODO 需要权衡一下 当前把下单后的订单号和nono号返回用于后续支付的接入，暂不考虑缓存下单后的订单
            this.ordersId = res.result.ordersId
            restaurantCenter.emit(RESTAURANT_EVENT.SAVE_ORDER, {
              order: res.result
            })
            this.setOrderWaitingAccepted(res.result)
          })
          return res.result
        }
        return Promise.reject({
          code: -10009,
          message: 'fail'
        })
      }, (err: any) => {
        console.log('save error', err)
        if (err.code === -161 || err.code === -165 || err.code === -166 || err.code === -167 || err.code === -399) { // 价格变动,包括餐品价格、税、服务费、优惠变化
        } else if (err.code === -52) { // 餐厅已打烊
        } else if (err.code === -395) { // 当前餐品不可售卖
        } else if (err.code === -602 || err.code === -603 || err.code === -604) { // 部分餐品不可售
          if (err.data) {
            err.data = unionBy(err.data, (message: IProductSaleError) => message.productNo + message.scaleNo).map((message: IProductSaleError) => {
              const scaleNo = message.scaleNo === '-1' ? '0' : message.scaleNo
              const viewProduct = productMobx.noToViewProductMap[message.productNo]
              const viewSale = viewProduct ? viewProduct.scales?.filter(scale => scale.status !== 'disable')?.find(sale => sale.no === scaleNo) : {} as IScale
              const viewCart = this.viewCartItems.find(item => item.productNo === message.productNo && item.scaleNo === scaleNo)
              const pks = map(this.viewCartItems.filter(item => item.productNo === message.productNo && item.scaleNo === scaleNo), 'pk')
              const sPks = map(flatten(map(this.viewCartItems.filter(item => item.swapBuyProducts?.length), 'swapBuyProducts')).filter(item => item?.productNo === message.productNo && item.scaleNo === scaleNo), 'pk')
              const fPks = map(flatten(map(this.viewCartItems.filter(item => item.fullItemNFreeProducts?.length), 'fullItemNFreeProducts')).filter(item => item?.productNo === message.productNo && item.scaleNo === scaleNo), 'pk')
              return {
                ...message,
                pks: [...pks, ...sPks, ...fPks],
                pic: viewProduct?.pic,
                optionStr: viewCart?.optionStr || '',
                productName: viewProduct?.name || '',
                scaleName: viewSale?.name || '',
                modifierName: message?.productType === 'modifier' ? productMobx.modifierNoToModifierMap?.[message.productNo]?.name : ''
              }
            })
          }
        } else if (err.code === -1752) { // 未提交配送费，请确认后重新下单
          this.setExpressList()
        }
        throw err
      })
    } else {
      return Promise.reject({
        code: -10009,
        message: 'fail'
      })
    }
  }

  /** 已下单餐品改价 */
  async reSave (data: { ordersId: string; openPriceX: number; detailId: string }) {
    this.setCacheCartItems(this.cartItems)
    const parmas = {
      ...data,
      addUserId: restaurantConfig.employeeInfo?.employeeId,
      addUserName: restaurantConfig.employeeInfo?.employeeName
    }
    const res: any = await OrderAPI.reSave(parmas)
    if (res?.result) await orderMobx.restore(res.result)
    await this.setCartItems(this.cacheCartItems.filter(item => !this.cartPks.includes(item.pk)))
    await this.setCacheCartItems()
    if (res?.result && this.ordersId) await this.syncMkt(true)
  }

  /** 重算优惠及费 */
  async syncMkt (isForce: boolean = false) {
    // 未下单，已经有未下单的餐品都不重新算优惠
    // remove 210526  || this.cartItems.length
    if (!this.ordersId && !isForce) {
      return true
    }
    // 判断是否要重算 当前力度控制到实际支付金额是否有变化
    // 1. managerDiscount 发生变化 2. mktFee 发生变化
    let isDiffMemberId = false
    let isDiffMemberCardId = false
    const orderMemberId = parseInt(orderMobx.order.memberId)
    const orderMemberGroupId = parseInt(orderMobx.order.memberGroupId)
    const posOrderMemberId = parseInt(orderMobx.posMember.memberId)
    const posOrderMemberGroupId = orderMobx.posMember.memberGroupId
    const cartMemberId = discountMobx.discountResult.memberId
    const cartMemberCardId = discountMobx.discountResult.memberCardId
    // 不同会员
    isDiffMemberId = orderMemberId !== cartMemberId || (restaurantConfig.app === 'pos' && posOrderMemberId !== cartMemberId)
    // 同会员，不同会员卡号
    isDiffMemberCardId = orderMemberGroupId !== cartMemberCardId || (restaurantConfig.app === 'pos' && posOrderMemberGroupId !== cartMemberCardId)
    if (this.cartResult.paidPrice !== orderMobx.order.paidFee || this.cartResult.tax !== orderMobx.order.tax || isDiffMemberId || isDiffMemberCardId || isForce) {
      const saveData = this.getSaveInfo()
      const theCartResultPaidPrice = this.cartResult.paidPrice
      const theCartResultTotalDiscountPrice = this.cartResult.totalDiscountPrice
      if (!saveData.infos?.ordersId) {
        return true
      }
      return OrderAPI.calMktFee(saveData).then((res: any) => {
        if (res?.result?.paidFee !== theCartResultPaidPrice) {
          // throw 'sync error'
          console.error('同步优惠计算不一致')
          console.error(`cartPaidFee: ${theCartResultPaidPrice}, orderPaidFee: ${res?.result?.paidFee}`)
          console.error(`cartDiscount: ${theCartResultTotalDiscountPrice}, orderDiscount: ${toDecimal(sumBy(res?.result?.discountList, 'fee'))}`)
          const computeerr = window.bo === 'cn' ? '同步优惠计算不一致' : 'Discount calculations are inconsistent'
          return Promise.reject({
            code: -10008,
            message: computeerr
          })
        } else {
          res?.result && orderMobx.restore(res.result)
        }
        return true
      })
    } else {
      return true
    }
  }

  async changeRejectAddProduct (status: boolean) {
    this.isReject = status
  }

  /** 撤销,桥接到订单的取消 */
  async cancel (cancelReason?: string) {
    // 取消订单会引发购物车订单餐品的变化
    return orderMobx.cancel(true, cancelReason)
  }

  /** 撤销,桥接到订单的取消 */
  async cancelProduct (detail: { [detailId: string]: number }, reason: string) {
    return orderMobx.cancelProduct(detail, reason).then(() => {
      restaurantCenter.emit(RESTAURANT_EVENT.CART_ORDERITEMS_CHANGED, cartMobx.viewOrderItems)
    })
  }

  /** 根据viewItems的Pk 设置当前购物车中餐品的remark */
  setCartProductRemark (data: Record<string, string>) {
    this.cartItems = this.cartItems.map(cartItem => {
      if (data[cartItem.pk] && cartItem.remark !== data[cartItem.pk]) {
        const newCartItem = { ...cartItem, remark: data[cartItem.pk] || '' }
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'change',
          cartItem: newCartItem
        })
        return newCartItem
      } else {
        return cartItem
      }
    })
  }

  /** 根据viewItems的Pk 修改单品备注remark */
  setCartSingleRemark (remark: string, pk: string) {
    this.cartItems = this.cartItems.map(cartItem => {
      if (cartItem.pk === pk && cartItem.remark !== remark) {
        const newCartItem = { ...cartItem, remark }
        restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_CHANGED, {
          type: 'change',
          cartItem: newCartItem
        })
        return newCartItem
      } else {
        return cartItem
      }
    })
  }

  /** 将订单中的餐品还原回购物车的统一转换方法 */
  private convertOrderItemToCartItem = convertOrderItemToCartItem

  /** 将未接单的订单(其中可能包含未接单的餐品)还原回购物车的统一转换方法 */
  private convertSaveItemToCartItem = convertSaveItemToCartItem

  /** 会员订单到购物车 */
  restoreOrderToCart (getViewDetailList?: (carts: ICartItem[]) => void) {
    if (orderMobx.viewDetailList.length) {
      // eslint-disable-next-line no-debugger
      // debugger;
      const viewDetailListChildMap = groupBy(orderMobx.viewDetailList.filter((item: IViewOrderDetail) => item.parentId !== '0'), 'parentId')
      const viewDetailList: IViewOrderDetail[] = orderMobx.viewDetailList
        // 过滤子餐品(换购品、赠品)
        .filter((item: IViewOrderDetail) => item.parentId === '0')
        // 过滤
        .filter((item: IViewOrderDetail) => item.productGroupNo !== 'zengsong')
        .map((item: IViewOrderDetail) => {
          // 还原换购品
          if (viewDetailListChildMap[item.detailId]?.length) {
            const swapBuyProducts = viewDetailListChildMap[item.detailId].filter((item: IViewOrderDetail) => item.productGroupNo === 'huangou')
            // const fullItemNFreeProducts = viewDetailListChildMap[item.detailId].filter((item: IViewOrderDetail) => item.productGroupNo === 'zengsong')
            return { ...item, swapBuyProducts } as IViewOrderDetail
          }
          return item
        })
      const viewDetailListToCart = viewDetailList.map(this.convertOrderItemToCartItem)
      if (!getViewDetailList) {
        this.cartItems = viewDetailListToCart
        this.ordersId = orderMobx.order.ordersId
        this.restoreOrderInfo()
        this.makeHash()
      } else {
        getViewDetailList(viewDetailListToCart)
      }
    }
  }

  /** 返回一个当前购物车的数据模型 */
  get (): ICartModel {
    return {
      ordersId: this.ordersId,
      info: this.info,
      cartItems: this.viewCartItems,
      orderItems: this.viewOrderItems,
      result: this.cartResult
    }
  }

  /** 返回退菜数据模型, 如果不传参数则认为剩下所有的餐品全退 */
  getVoid (voidDetailIdMap?: { [detailId: string]: number }): ICartModel {
    if (voidDetailIdMap) {
      return {
        ordersId: this.ordersId,
        info: this.info,
        cartItems: [], // 购物车餐品不会退
        orderItems: compact(this.viewOrderItems.map(orderItem => {
          const voidItem = voidDetailIdMap[orderItem.detailId]
          // 如果推整个餐品则口料全部返回
          if (voidItem) {
            return { ...orderItem }
          } else {
            if (!orderItem.modifierGroups) {
              return false
            }
            const modifierGroups = orderItem.modifierGroups.map(modifierGroup => {
              const modifiers = modifierGroup.modifiers.filter(modifier => voidDetailIdMap[modifier.detailId as string])
              if (modifiers.length) {
                return { ...modifierGroup, modifiers }
              } else {
                return false
              }
            })
            if (compact(modifierGroups).length) {
              return { ...orderItem, modifierGroups: compact(modifierGroups) }
            } else {
              return false
            }
          }
        })),
        result: this.cartResult
      }
    } else {
      // 当前只支持到餐品级别
      return {
        ordersId: this.ordersId,
        info: this.info,
        cartItems: [], // 购物车餐品不会退
        orderItems: this.viewOrderItems.filter(orderItem => !orderItem.refundCnt).map((orderItem) => {
          return {
            ...orderItem,
            refundCnt: -orderItem.cnt,
            actualCnt: 0
          }
        }),
        result: this.cartResult
      }
    }
  }

  /** 获取当前购物车hash */
  getHash () {
    const cartItems = this.cartItems.filter((item: ICartItem) => !this.pkToViewCartItemMap?.[item.pk]?.disabled)
    return JSON.stringify(toJS(cartItems)) + JSON.stringify(toJS(this.info))
  }

  /** 标记一个购物车的标记位，优化是否需要重新下单的处理 */
  makeHash () {
    this.lastHash = this.getHash()
  }

  /** 置换当前购物车中的pk */
  replacePk () {
    if (this.cartItems.length) {
      this.cartItems = this.cartItems.map(cartItem => {
        return replaceCartItemPk(cartItem)
      })
      restaurantCenter.emit(RESTAURANT_EVENT.CART_CHANGED)
    }
  }

  /** 混合标记位 */
  setIsMixture (isMixture: boolean) {
    this.isMixture = isMixture
  }

  /** 设置免税 */
  setTaxFree (taxCategoryId: number) {
    // const theTaxItem = this.cartResult.taxItems.find(item => item.taxCategoryId === taxCategoryId)
    // if (theTaxItem) {
    //   this.cartItems = this.cartItems.map(item => {
    //     if (productMobx.noToViewProductMap[item.productNo].taxCategoryId === taxCategoryId) {
    //       if (theTaxItem.amount > 0) {
    //         return { ...item, isTaxFree: true }
    //       } else {
    //         return { ...item, isTaxFree: false }
    //       }
    //     } else {
    //       return item
    //     }
    //   })
    // }
    if (this.info.freeTaxList.includes(taxCategoryId)) {
      this.info.freeTaxList = this.info.freeTaxList.filter(tx => tx !== taxCategoryId)
    } else {
      this.info.freeTaxList.push(taxCategoryId)
    }
  }

  /** 获取当前购物车就餐类型 */
  getSaveEatType () {
    // 取出当前储存的信息
    const saveData = this.getSaveInfo()
    // 返回用餐类型
    return saveData?.infos?.eatType || ''
  }

  /** 批量更改购物车价格 */
  updateCartItemPrice (no: string, price: number) {
    this.cartItems = this.cartItems.map(item => {
      if (item.productNo === no) {
        return {
          ...item,
          price
        }
      }
      return {
        ...item,
      }
    })
  }

  /** 设置订单合并展示 */
  setOrderMerge (orderMerge: boolean) {
    this.orderMerge = orderMerge
  }

  /** 设置POS订单手机支付 */
  setPosOrderPay (posOrderPay: boolean) {
    this.posOrderPay = posOrderPay
  }

  /** 初始化选中的打包项 */
  initCartPackFkeys () {
    this.cartPackFkeys = {}
    this.viewCartItems.forEach(item => {
      if (item.isOrderSwapBuy) {
        this.cartPackFkeys[`${item.fkey}_${item.pk}`] = item.isTogo ? item.cnt : 0
      } else {
        this.cartPackFkeys[item.fkey] = item.isTogo ? item.cnt : 0
      }
      item.swapBuyProducts?.forEach(swapItem => {
        this.cartPackFkeys[`${swapItem.fkey}_swapBuy_${swapItem.pk}`] = swapItem.isTogo ? swapItem.cnt : 0
      })
      item.fullItemNFreeProducts?.forEach(fullNFreeItem => {
        this.cartPackFkeys[`${fullNFreeItem.fkey}_fullNFree_${fullNFreeItem.pk}`] = fullNFreeItem.isTogo ? fullNFreeItem.cnt : 0
      })
    })
  }

  /** 设置打包fkey */
  setCarPackFkeys (fkey: string, cnt: number, users?: string[]) {
    if (users?.length) {
      users.forEach(user => {
        this.cartPackFkeys[`${fkey}_${user}`] = cnt
      })
      return
    }
    this.cartPackFkeys[fkey] = cnt
  }

  /** 是否需要打包 */
  setNeedPack (isPack: boolean) {
    this.needPack = isPack
    this.initCartPackFkeys()
  }

  /** 全选打包 */
  setAllCartItemPackCheck () {
    const cartPackFkeys: any = {}
    this.cartItems.forEach(cartItem => {
      if (!productMobx.noToIsCanPackMap[cartItem.productNo] && !this.pkToViewCartItemMap[cartItem.pk]?.isCanTogo) {
        return
      }
      if (cartItem.isOrderSwapBuy) {
        cartPackFkeys[`${cartItem.fkey}_${cartItem.pk}`] = this.isPackCheckAll ? 0 : cartItem.cnt
      } else {
        cartPackFkeys[cartItem.fkey] = this.isPackCheckAll ? 0 : cartItem.cnt
      }
      cartItem.swapBuyProducts?.forEach(swapItem => {
        cartPackFkeys[`${swapItem.fkey}_swapBuy_${swapItem.pk}`] = this.isPackCheckAll ? 0 : swapItem.cnt
      })
      cartItem.fullItemNFreeProducts?.forEach(fullNFreeItem => {
        cartPackFkeys[`${fullNFreeItem.fkey}_fullNFree_${fullNFreeItem.pk}`] = this.isPackCheckAll ? 0 : fullNFreeItem.cnt
      })
    })
    this.cartPackFkeys = cartPackFkeys
  }

  /** 确认打包 */
  confirmCartItemPack () {
    const mp = new Map()
    const cartItems = cloneDeep(this.cartItems)
    const cartPackFkeys = this.cartPackFkeys

    cartItems.forEach(item => {
      const cartItem = cloneDeep(item)
      const packPk = doPk()
      const unPackPk = doPk()
      const packCnt = cartPackFkeys[cartItem.isOrderSwapBuy ? `${cartItem.fkey}_${cartItem.pk}` : cartItem.fkey] || 0
      const packedKey = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: 1, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
      const unPackKey = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: 0, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })

      // 处理换购
      const swapBuySameKey0 = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: 0, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
      const swapBuySameKey1 = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo: 1, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
      const swapBuySameCnt = (cartPackFkeys[cartItem.isOrderSwapBuy ? `${packedKey}_${packPk}` : packedKey] || 0) + (cartPackFkeys[cartItem.isOrderSwapBuy ? `${unPackKey}_${unPackPk}` : unPackKey] || 0)
      const swapBuyProducts = flatten(
        this.cartItems
          .filter(item => {
            const { productNo, scaleNo, modifierGroups, addUserId, startTime, isOrderSwapBuy, productGroups } = item
            return createFkey({ productNo, scaleNo, modifierGroups, addUserId, isTogo: 0, startTime, isSeat: item.seat || '-1', isOrderSwapBuy, productGroups, openPriceX: item.openPriceX }) === swapBuySameKey0 || createFkey({ productNo, scaleNo, modifierGroups, addUserId, isTogo: 0, startTime, isSeat: item.seat || '-1', isOrderSwapBuy, productGroups, openPriceX: item.openPriceX, price: item.price }) === swapBuySameKey1
          })
          .map(item => item.swapBuyProducts || [])
      )
      let packedSwapBuyProducts: any
      let unPackSwapBuyProducts: any
      // if (cartItem.swapBuyProducts?.length) {
      swapBuyProducts?.forEach(swapItem => {
        const isTogo = cartPackFkeys[`${swapItem.fkey}_swapBuy_${swapItem.pk}`] ? 1 : 0
        packedSwapBuyProducts = packedSwapBuyProducts || []
        packedSwapBuyProducts.push({
          ...swapItem, isTogo, pk: doPk(), parentPk: packPk
        })
        unPackSwapBuyProducts = unPackSwapBuyProducts || []
        unPackSwapBuyProducts.push({
          ...swapItem, isTogo, pk: doPk(), parentPk: unPackPk
        })
      })
      packedSwapBuyProducts = reduceSwapBuy({
        swapBuyProducts: packedSwapBuyProducts,
        length: (mp.get(packedKey)?.cnt || 0) + swapBuySameCnt,
      })
      unPackSwapBuyProducts = reduceSwapBuy({
        swapBuyProducts: unPackSwapBuyProducts,
        start: (mp.get(packedKey)?.cnt || 0) + swapBuySameCnt,
        length: (mp.get(unPackKey)?.cnt || 0) + cartItem.cnt - swapBuySameCnt,
      })
      // }
      const _packCnt = ((mp.get(packedKey)?.cnt || 0) + packCnt)
      const _unPackCnt = ((mp.get(unPackKey)?.cnt || 0) + cartItem.cnt - packCnt)
      const psbp = [
        ...(packedSwapBuyProducts || []),
        ...(unPackSwapBuyProducts || [])
      ]?.filter(item => !!item).splice(0, _packCnt)
      const upsbp = [
        ...(packedSwapBuyProducts || []),
        ...(unPackSwapBuyProducts || [])
      ]?.filter(item => !!item).splice(_packCnt, _packCnt + _unPackCnt)
      const _psbp = psbp.length ? psbp.map(item => {
        item.parentPk = packPk
        return item
      }) : undefined
      const _upsbp = upsbp.length ? upsbp.map(item => {
        item.parentPk = unPackPk
        return item
      }) : undefined

      // mp set
      mp.set(packedKey, {
        ...cartItem,
        swapBuyProducts: _psbp,
        productGroups: cloneDeep(cartItem.productGroups)?.map(group => {
          const _group = cloneDeep(group)
          _group.productGroupDetails = _group.productGroupDetails?.map(product => {
            const _product = cloneDeep(product)
            _product.isTogo = 1
            _product.pk = doPk()
            return _product
          })
          return _group
        }),
        cnt: _packCnt,
        fkey: packedKey,
        isTogo: 1,
        pk: packPk
      })
      mp.set(unPackKey, {
        ...cartItem,
        swapBuyProducts: _upsbp,
        productGroups: cloneDeep(cartItem.productGroups)?.map(group => {
          const _group = cloneDeep(group)
          _group.productGroupDetails = _group.productGroupDetails?.map(product => {
            const _product = cloneDeep(product)
            _product.isTogo = 0
            _product.pk = doPk()
            return _product
          })
          return _group
        }),
        cnt: _unPackCnt,
        fkey: unPackKey,
        isTogo: 0,
        pk: unPackPk
      })
    })

    this.needPack = false
    this.cartItems = Array.from(mp.values()).filter(item => item.cnt).map(item => {
      const _item = cloneDeep(item)
      _item.swapBuyProducts = item.swapBuyProducts?.map((swapItem: any) => {
        const _swapItem = cloneDeep(swapItem)
        _swapItem.parentPk = item.pk
        _swapItem.pk = doPk()
        return _swapItem
      })
      return _item
    })
    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED, {
      type: 'change',
      cartItems: this.cartItems,
      cache: true
    })
    // 自动计算满送
    // this.autoFullNFree()
  }

  // 全部打包或者取消打包
  packAll (isTogo: 0 | 1) {
    if (!this.cartItems?.length) {
      return
    }
    const _reset = (cartItem: any) => {
      if (!cartItem?.isCanTogo) {
        return cartItem
      }
      const fkey = createFkey({ productNo: cartItem.productNo, scaleNo: cartItem.scaleNo, modifierGroups: cartItem.modifierGroups, addUserId: cartItem.addUserId, isTogo, startTime: cartItem.startTime, isSeat: cartItem.seat || '-1', isOrderSwapBuy: cartItem.isOrderSwapBuy, productGroups: cartItem.productGroups, openPriceX: cartItem.openPriceX, price: cartItem.price })
      cartItem.fkey = fkey
      cartItem.isTogo = isTogo
      return cartItem
    }
    this.cartItems.forEach(cartItem => {
      cartItem = _reset(cartItem)
      cartItem.swapBuyProducts?.forEach(swapItem => {
        _reset(swapItem)
      })
      cartItem.fullItemNFreeProducts?.forEach(fullNFreeItem => {
        _reset(fullNFreeItem)
      })
      cartItem.productGroups?.forEach(group => {
        group.productGroupDetails?.forEach(product => {
          _reset(product)
        })
      })
    })

    restaurantCenter.emit(restaurantCenter.RESTAURANT_EVENT.CART_ITEMS_BATCH_CHANGED, {
      type: 'change',
      cartItems: this.cartItems,
      cache: true
    })
  }
}
cartAuto()
export default new Cart()
export { createCartItem, reduceSwapBuy, getViewItems, replaceCartItemPk }
